// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:16:13.670Z
// Property: Glen at Polo Park (ID: 6737460151191756)
// Collections: 33 amenities, 7 floorplans (live), 19 photos, 74 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191756",
  "property_external_id": "5026489",
  "property_zillow_url": "https://www.zillow.com/b/glen-at-polo-park-bentonville-ar-BS8RPC/",
  "property_apartments_url": "https://www.apartments.com/glen-at-polo-park-bentonville-ar/s95nrh6",
  "property_google_business_url": "https://www.google.com/maps/place/Glen+at+Polo+Park/data=!4m2!3m1!1s0x0:0x129498822c1d0464?sa=X&ved=2ahUKEwiR-ICCurySAxU7hv0HHVkCDhgQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321141054",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "glen-at-polo-park",
  "property_name": "Glen at Polo Park",
  "property_website_url": "https://www.glenpolopark.com/",
  "property_domain": "https://www.glenpolopark.com/",
  "property_address": "6601 SW Mallet Rd",
  "property_full_address": "6601 SW Mallet Rd, Bentonville, AR 72713",
  "property_address_1": "6601 SW Mallet Rd",
  "property_address_2": null,
  "property_address_city": "Bentonville",
  "property_address_state": "AR",
  "property_address_zip_full": "72713-8132",
  "property_address_zip": "72713",
  "property_address_country": "US",
  "property_address_county": "Benton County",
  "property_neighborhood_address": "Outer Central Benton County",
  "property_address_latitude": "36.3137482",
  "property_address_longitude": "-94.3070793",
  "property_email": "glenpolopark@rreafresidential.com",
  "property_phone": "(479) 259-1147",
  "property_call_tracking_phone": "479-339-8538",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your ideal home at Glen at Polo Park in Bentonville, AR! Choose from spacious one, two, or three-bedroom floor plans, and enjoy premium amenities including a 24-hour fitness center, two sparkling pools, and a dog park. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Discover Your Ideal Home at Glen at Polo Park in Bentonville, AR!**\n\nWelcome to Glen at Polo Park, where comfort meets style in a vibrant community setting. Our thoughtfully designed apartments offer a variety of floor plans to suit every lifestyle, featuring one, two, and three-bedroom layouts that prioritize your space and privacy. Our stunning community amenities make living here a true delight. \n\nEnjoy evenings by the gas fire pit or indulge in a delicious BBQ in our community grill area. For fitness enthusiasts, the 24-hour fitness center boasts state-of-the-art equipment, while two sparkling pools provide a refreshing escape. Families will appreciate our two playgrounds and dog park, ensuring fun for everyone—including your furry friends!  \n\nConvenience is key at Glen at Polo Park. Residents benefit from ample parking, covered parking options, and a dedicated team for 24-hour on-call maintenance and management. Stay productive in our business center equipped with essential tools or relax in our inviting clubroom. Our gated community offers enhanced security, while access to the Vulcan trail provides outdoor enthusiasts with direct pathways for walking, jogging, and biking.\n\nWhether you’re seeking short-term lease options or planning a longer stay, Glen at Polo Park has something for everyone. Don't miss out on calling this vibrant community your home. \n\nFind your new home today—explore our availability and schedule a tour to experience all that Glen at Polo Park has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-74f2-722d-a42b-bcbaf58e9479.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment building exterior with a swimming pool and lounge chairs in the foreground.",
    "public_id": "019e60ef-74f2-722d-a42b-bcbaf58e9479",
    "storage_key": "property/6737460151191756/019e60ef-74f2-722d-a42b-bcbaf58e9479.webp",
    "width": 3072,
    "height": 2050
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "356",
  "property_year_built": "2007",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.41573033707866",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply (e.g., Pit Bulls, Rottweilers, German Shepherds, Huskies, Malamutes, Dobermans, Chow Chows, St. Bernards, Great Danes, Akitas, Staffordshire Terriers, American Bulldogs, or any hybrid/mixed breed of these). All pets must be spayed or neutered before move‑in.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://glenatpolopark.loftliving.com/login",
  "property_apply_now_url": "https://8921442.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-cda3-72ba-8c9d-87d514260461.webp",
  "property_primary_logo_media": {
    "alt_text": "Glen at Polo Park Apartment Homes logo",
    "public_id": "019e1e43-cda3-72ba-8c9d-87d514260461",
    "storage_key": "property/6737460151191756/019e1e43-cda3-72ba-8c9d-87d514260461.webp",
    "width": 300,
    "height": 56
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-cdae-7665-9e64-3805e586c1cb.webp",
  "property_secondary_logo_media": {
    "alt_text": "Glen at Polo Park Apartment Homes logo",
    "public_id": "019e1e43-cdae-7665-9e64-3805e586c1cb",
    "storage_key": "property/6737460151191756/019e1e43-cdae-7665-9e64-3805e586c1cb.webp",
    "width": 300,
    "height": 56
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-cdae-7665-9e64-3805e586c1cb.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Glen at Polo Park Apartment Homes logo",
    "public_id": "019e1e43-cdae-7665-9e64-3805e586c1cb",
    "storage_key": "property/6737460151191756/019e1e43-cdae-7665-9e64-3805e586c1cb.webp",
    "width": 300,
    "height": 56
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-cdc0-737e-bee0-f6f73b15ff25.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Glen at Polo Park Apartment Homes logo.",
    "public_id": "019e1e43-cdc0-737e-bee0-f6f73b15ff25",
    "storage_key": "property/6737460151191756/019e1e43-cdc0-737e-bee0-f6f73b15ff25.webp",
    "width": 300,
    "height": 56
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0b3766",
  "property_secondary_color": "#e2effd",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "730 - 1370",
  "property_sqft_min": "730",
  "property_sqft_max": "1370",
  "property_price_range": "975 - 1600",
  "property_price_min": "975",
  "property_price_max": "1600",
  "property_available_units": 27,
  "property_facebook_url": "https://www.facebook.com/GlenPoloParkApts",
  "property_instagram_url": "https://www.instagram.com/glen_at_polo_park/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJSxZhr9cOyYcRZAQdLIKYlBI",
  "property_youtube_url": "https://www.youtube.com/watch?v=6xmCD6U25qA",
  "property_yelp_url": "https://www.yelp.com/biz/glen-at-polo-park-by-hamilton-point-investments-bentonville",
  "property_tiktok_url": "https://www.tiktok.com/@glen.at.polo.park",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Glen at Polo Park",
  "property_home_romance_title": "Embrace Comfort and Joy in Your New Community Home",
  "property_home_amenities_blurb": "<p>You can find innovation and influence in Bentonville, AR, at <a href=\"/floor-plans/\">Glen at Polo Park Apartments</a>. Experience all of the nuances our resort-style community and neighborhood provide.</p>",
  "property_home_floorplans_blurb": "<p>Located in Bentonville, AR we offer stunning <a href=\"/floor-plans/\">1-, 2- and 3-bedroom apartment homes</a> with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Glen at Polo Park is more than just a place to live, it is a lifestyle.</p>",
  "property_home_gallery_blurb": "At Glen at Polo Park in Bentonville, AR, modern comfort meets vibrant community life. Choose from spacious one to three-bedroom floor plans, enjoy amenities like a refreshing pool, fitness center, and pet play area. Imagine unwinding on your private balcony or cozying up by the gas fire pit. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Glen at Polo Park in Bentonville, AR! Explore our diverse floor plans—one, two, and three-bedroom apartments—and experience the best of local favorites and nearby attractions. See what’s around our community and uncover your new lifestyle today!",
  "property_home_reviews_blurb": "Nestled in the serene heart of Centerton, the Glen at Polo Park pairs beautiful, spacious apartments with a supportive community atmosphere. Residents rave about the “friendly staff” and “quiet, pet-friendly environment,” making it an ideal haven for all. Experience tranquility, comfort, and care at Glen at Polo Park today!",
  "property_neighborhood_blurb": "<p>Located in Bentonville, AR we offer stunning <a href=\"/floor-plans/\">1-, 2- and 3-bedroom apartment homes</a> with open floorplans, contemporary design, and <a href=\"/amenities/\">stylish finishes</a>. Glen at Polo Park is more than just a place to live, it is a lifestyle.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>We are delighted to present elegant <a href=\"/floor-plans/\">homes for rent</a> in Bentonville, Arkansas. Our apartments feature all the distinct and desirable amenities you've been dreaming of. Your future starts with us at Glen at Polo Park.</p>",
  "property_applynow_blurb": "Discover your perfect home at Glen at Polo Park in Bentonville, AR! Choose from spacious one, two, or three-bedroom floor plans and enjoy top-notch amenities like a 24-hour fitness center, gas grills, two sparkling pools, and a dog park. Find your new home and lease online today!",
  "property_contactus_blurb": "Discover your ideal home at Glen at Polo Park in Bentonville, AR! Explore our diverse range of floor plans, including one, two, and three-bedroom options. Have questions? Contact our leasing team today and let us help you find the perfect apartment to suit your lifestyle!",
  "property_faqs_blurb": "At Glen at Polo Park in Bentonville, AR, discover the perfect home with our stylish one, two, and three-bedroom floor plans. Have questions? Our FAQs page is the ideal resource to get all the answers you need about our vibrant community. Explore now for a seamless living experience!",
  "property_floorplans_blurb": "<p>Our pet-friendly one, two, and three-bedroom residences emanate upscale style and top-notch functionality. Glen at Polo Park apartments' luxurious interiors include <a href=\"/amenities/\">features</a> that will energize extraordinary living.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Welcome to Glen at Polo Park in Bentonville, AR! Our spacious one, two, and three-bedroom apartments offer stunning amenities like gas grills, a 24-hour fitness center, and a dog park. Discover your perfect home with our interactive community map—explore available apartments and pricing today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover your ideal home at Glen at Polo Park in Bentonville, AR! With versatile floor plans including one, two, and three-bedroom apartments, there's a perfect fit for everyone. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy living together in comfort and style! ",
  "property_residentaccess_blurb": "Welcome to Glen at Polo Park in Bentonville, AR, where you can explore our spacious one, two, and three-bedroom floor plans designed for modern living. Access your resident portal to pay rent, schedule maintenance, and enjoy all the amenities we offer. Experience the convenience today!",
  "property_reviews_blurb": "At Glen at Polo Park in Bentonville, residents thrive in spacious, beautifully maintained apartments with friendly neighbors and a tranquil atmosphere. One happy resident shares, “This property is not only beautiful but has the best staff.” Join a community where service meets comfort—find your home with us today!",
  "property_created_at": "1752257090665",
  "property_scheduletour_blurb": "Discover your ideal home at Glen at Polo Park in Bentonville, AR! We offer spacious one, two, and three-bedroom floor plans to suit your lifestyle. Schedule a tour today and see what our residents have to say about the welcoming community that awaits you! View all options now!",
  "property_thankyou_blurb": "Thank you for your interest in Glen at Polo Park, Bentonville's premier apartment community! Explore our spacious one, two, and three-bedroom floor plans to find your perfect home. A team member will contact you shortly to assist with your inquiry. We look forward to welcoming you to our vibrant community!",
  "property_virtualtours_blurb": "<p>At Glen at Polo Park, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Glen at Polo Park",
  "property_seo_title_home": "Glen at Polo Park | Apartments in Bentonville, AR",
  "property_seo_description_home": "Experience modern living at Glen at Polo Park in Bentonville, AR! Our spacious one, two, and three-bedroom apartments offer exceptional floor plans to fit your lifestyle. Enjoy top-notch amenities including a 24-hour fitness center, two sparkling pools, a dog park, and controlled access for peace of mind. With convenient features like covered parking, gas grills, and a business center, you’ll have everything you need right at your fingertips. Discover your perfect home today—explore our floor plans and amenities now!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Bentonville, AR",
  "property_seo_description_floorplans": "Discover your ideal living space at Glen at Polo Park in Bentonville, AR! Explore our diverse floor plans, featuring one, two, and three-bedroom apartments designed for comfort and style. Whether you're looking for spaciousness or a cozy retreat, we have the perfect option for you. Browse our available apartment homes today and find your perfect floor plan!",
  "property_seo_title_amenities": "Amenities | Bentonville, AR Apartments for Rent",
  "property_seo_description_amenities": "Discover your ideal home at Glen at Polo Park in Bentonville, AR! Choose from spacious one, two, and three-bedroom floor plans while enjoying first-class amenities such as 24-hour fitness centers, sparkling pools, and gas grills. Our gated community offers ample parking, a dog park, and convenient access to the Vulcan trail. Experience luxury living with top-notch services like on-call maintenance and a business center. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Bentonville, AR",
  "property_seo_description_gallery": "Experience luxurious living at Glen at Polo Park in Bentonville, AR! Discover our diverse floor plans—one, two, and three-bedroom apartments tailored for your lifestyle. Enjoy top-notch amenities like a 24-hour fitness center, two sparkling pools, a fully-equipped business center, dog park, and gas grills. Our gated community ensures safety and convenience with covered parking, on-site management, and emergency maintenance. Picture yourself living here—explore our stunning photo gallery today!",
  "property_seo_title_virtualtours": "Virtual Tours | Glen at Polo Park Apartments",
  "property_seo_description_virtualtours": "Explore Glen at Polo Park in Bentonville, AR! Our diverse floor plans include stylish one, two, and three-bedroom apartments designed to meet your needs. Take a virtual tour today and discover your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Glen at Polo Park Apartments",
  "property_seo_description_interactivemap": "Discover your dream apartment at Glen at Polo Park in Bentonville, AR! Choose from our spacious one, two, and three-bedroom floor plans designed for your lifestyle. Enjoy top-notch amenities like 24-hour fitness and business centers, sparkling pools, a dog park, and gas fire pits. Our gated community offers ample parking, convenient car wash stations, and 24-hour emergency maintenance for peace of mind. Ready to find your next home? Use our interactive community map to explore available apartments and pricing today! ",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bentonville, AR",
  "property_seo_description_neighborhood": "Discover Glen at Polo Park in Bentonville, AR—your ideal apartment community! Explore spacious one, two, and three-bedroom floor plans tailored to fit your lifestyle. Dive into the vibrant neighborhood filled with local favorites and essential points of interest. See what's around our community and start your next adventure today!",
  "property_seo_title_contact": "Contact Us | Glen at Polo Park",
  "property_seo_description_contact": "Discover your new home at Glen at Polo Park in Bentonville, AR! Explore our diverse floor plans, including spacious one, two, and three-bedroom apartments designed for comfort and style. Have questions? Contact our dedicated leasing team today and let us help you find the perfect apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in Bentonville, AR",
  "property_seo_description_faqs": "Discover your perfect home at Glen at Polo Park in Bentonville, AR! Choose from our spacious one, two, and three-bedroom floor plans, all in a gated community with premium amenities including 24-hour fitness, sparkling pools, a dog park, and gas grills. Enjoy additional features like covered parking, emergency maintenance, and easy access to Vulcan Trail. Have questions? Browse our FAQs page for everything you need to know about our vibrant community and how we prioritize your comfort. Make your move today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bentonville, AR",
  "property_seo_description_reviews": "Discover the perfect blend of comfort and luxury at Glen at Polo Park in Bentonville, AR! Explore our diverse floor plans, including one, two, and three-bedroom apartments, designed to meet your lifestyle needs. Enjoy top-notch amenities like a 24-hour fitness center, two sparkling pools, a dog park, and gas grills, all within a secure gated community. With 24/7 maintenance and management, we ensure your living experience is stress-free. See what our residents have to say about living at our vibrant community! Experience the Glen at Polo Park difference today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Bentonville, AR",
  "property_seo_description_applynow": "Discover your dream home at Glen at Polo Park in Bentonville, AR! Our thoughtfully designed one, two, and three-bedroom apartments offer modern amenities like a 24-hour fitness center, gas grills, and sparkling pools. Enjoy gated community living with features like ample parking, direct access to Vulcan Trail, and on-call management to cater to your needs. With a pet-friendly dog park, playgrounds, and a convenient business center, everything you need is here. Don’t wait—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Glen at Polo Park",
  "property_seo_description_residentaccess": "\"Welcome to Glen at Polo Park in Bentonville, AR! Access your resident portal now to conveniently pay rent, schedule maintenance, and discover more features tailored to your living experience. Stay connected and manage your home effortlessly!\"",
  "property_seo_title_referafriend": "Refer A Friend | Glen at Polo Park",
  "property_seo_description_referafriend": "\"Discover the joy of living at Glen at Polo Park in Bentonville, AR! Great friends make great neighbors - refer a friend to our vibrant community today and enjoy exclusive rewards. Join us in creating a welcoming home together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Glen at Polo Park",
  "property_seo_description_scheduletour": "Discover your dream home at Glen at Polo Park in Bentonville, AR! Schedule a tour today and explore our stunning apartment community featuring modern amenities, vibrant surroundings, and a welcoming atmosphere. Don’t miss out—your perfect apartment awaits!",
  "property_seo_title_privacy": "Privacy Policy | Glen at Polo Park",
  "property_seo_description_privacy": "Discover peace of mind at Glen at Polo Park in Bentonville, AR. Our comprehensive privacy policy outlines how we protect your personal information. Feel secure and informed as you explore your future home. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Glen at Polo Park",
  "property_seo_description_accessibility": "\"At Glen at Polo Park in Bentonville, AR, we prioritize digital accessibility for all. Discover our commitment to inclusivity and how we strive to make every experience seamless. Explore our Accessibility Statement today—because we believe everyone deserves to feel at home online!\"",
  "property_seo_title_sitemap": "Sitemap | Glen at Polo Park",
  "property_seo_description_sitemap": "\"Explore Glen at Polo Park in Bentonville, AR! Navigate our community features, floor plans, and amenities effortlessly. View our comprehensive sitemap to find everything you need to make Glen at Polo Park your new home!\"",
  "property_seo_title_thankyou": "Thank You | Glen at Polo Park",
  "property_seo_description_thankyou": "Thank you for reaching out to Glen at Polo Park in Bentonville, AR! Your information has been received, and a member of our team will contact you shortly. Discover your new home in our vibrant community – we can't wait to assist you in finding the perfect apartment!",
  "property_seo_title_pets": "Pet Policy | Apartments in Bentonville, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293615700",
  "amenities": [
    {
      "id": "ec_f555710231d2adfb8f5de84b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "2 Resort-Style Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a58f6702a3ea165f506866a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Availability",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3135397c2024543b94c50e3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Emergency",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e48d2d6d5a7728aa5d0f035a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0c24a81371030a7297926b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Attached and Detached Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_891888532f04dd26c5bd0acb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Barbecue Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d6caecb1f204e549564d861",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Comfortable Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_644f2d765f1f5a8defc77e25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc8b172a04f2ab37858f7cf6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Dog Wash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13e7362dc77d0f5fb52b98af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdeadfcec71f95c0a5d5cee2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a80b5775807ce4ffd97212fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Indoor Basketball Half Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9d8848cc249425cd4a20ef5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ea85d8efd014af623b7f351",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Pet‑friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3eba9d3db26698aea889211c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6f798112f0fcedb8efb36a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b22b3e8e68a20eb796ddb13",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "20% Monthly Discount for Walmart Inc. Employees",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52ef7d56fcf268c8976400a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "New Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_255c35171b21a5d73701836b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Abundant Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0016bb78be096cedc104e35",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Attached and Detached Garages",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e42ad81ad99d1eb3dba330ba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08c3f49ad8e1fbf450dd47b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a539d3f05bf0b9e846d4c9f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Large Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_943925f07fa12fa15f74caf1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aaea77344e0fe824abbbb71a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Open Floor Plan Design",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4820b768efa41997f0e462bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24befa59909912729713d67d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "Stove",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24f1ed2a369da89674b28b16",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "All New Stainless Steel Appliance Package",
      "amount": "false",
      "description": "Coming Soon (in Select Apartment Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28314dabd00c48aa323c3bf0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "New Carpet and Flooring",
      "amount": "false",
      "description": "Coming Soon (in Select Apartment Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5937d41f39c2cc9fcdcdacf1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "New Granite Countertops",
      "amount": "false",
      "description": "Coming Soon (in Select Apartment Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e81db437f4785b3049062c56",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "New Hardware Package",
      "amount": "false",
      "description": "Coming Soon (in Select Apartment Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33f5a7ad3012f026d1c8c4e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "New Lighting Package",
      "amount": "false",
      "description": "Coming Soon (in Select Apartment Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82f318640fa5439c4ffe5915",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "external_id": "false",
      "title": "New Two‑tone Paint",
      "amount": "false",
      "description": "Coming Soon (in Select Apartment Homes)",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_74df534e-4a0d-4f6a-8b55-8988de9a237d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-0488-7717-825d-d64d65b361f4.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a06832-0488-7717-825d-d64d65b361f4",
        "storage_key": "property/6737460151191756/01a06832-0488-7717-825d-d64d65b361f4.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating. An oasis for residents to enjoy.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d97de8f2-4d53-4b48-9bc2-79f53b573899",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-012f-71bf-bdce-21cf7965a52c.webp",
      "image_media": {
        "alt_text": "A spacious bedroom with a king-sized bed, nightstands, and a window.",
        "public_id": "01a06832-012f-71bf-bdce-21cf7965a52c",
        "storage_key": "property/6737460151191756/01a06832-012f-71bf-bdce-21cf7965a52c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush king-sized bed, elegant nightstands, and plenty of natural light from the large window.",
      "link": "",
      "alt_text": "A spacious bedroom with a king-sized bed, nightstands, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ccb751f0-8cb0-4d3b-a64d-ba815b038282",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-043f-7410-a550-f642667e53fa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark gray cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "01a06832-043f-7410-a550-f642667e53fa",
        "storage_key": "property/6737460151191756/01a06832-043f-7410-a550-f642667e53fa.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring dark gray cabinetry, sleek stainless steel appliances including a microwave, range, and refrigerator, complemented by granite countertops and a deep sink.",
      "link": "",
      "alt_text": "Modern kitchen with dark gray cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0c24cf15-92e2-41bf-a924-ad10a6ccaa96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-043d-743d-89bc-2b69faa0beca.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, chairs, and a built-in desk with a granite countertop.",
        "public_id": "01a06832-043d-743d-89bc-2b69faa0beca",
        "storage_key": "property/6737460151191756/01a06832-043d-743d-89bc-2b69faa0beca.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy meals in this elegant dining area, complete with a stylish table and chairs. A convenient built-in desk offers a perfect spot for work or study.",
      "link": "",
      "alt_text": "Dining area with a round table, chairs, and a built-in desk with a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_360b00ad-3d2f-4c4a-89f4-4eb1092a96a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-042a-7048-a566-09e6d3a510e7.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with a large sectional sofa and coffee table, plus bar seating near large windows.",
        "public_id": "01a06832-042a-7048-a566-09e6d3a510e7",
        "storage_key": "property/6737460151191756/01a06832-042a-7048-a566-09e6d3a510e7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish and comfortable resident lounge, featuring plush seating and ample space for socializing.",
      "link": "",
      "alt_text": "Comfortable seating area with a large sectional sofa and coffee table, plus bar seating near large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fded7e5c-5537-4ae4-8839-5bcda89101b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-0101-72c9-98a2-6a552cabeeb9.webp",
      "image_media": {
        "alt_text": "Kitchen with a breakfast bar and three stools.",
        "public_id": "01a06832-0101-72c9-98a2-6a552cabeeb9",
        "storage_key": "property/6737460151191756/01a06832-0101-72c9-98a2-6a552cabeeb9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a breakfast bar with bar stools, stainless steel appliances, and white cabinetry. Perfect for casual dining and entertaining.",
      "link": "",
      "alt_text": "Kitchen with a breakfast bar and three stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_34648484-aa0a-4464-823b-447534dfc746",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-0450-73ff-8d98-993ba0339698.webp",
      "image_media": {
        "alt_text": "Spacious living area with vaulted ceilings, a ceiling fan, and an open view to the kitchen.",
        "public_id": "01a06832-0450-73ff-8d98-993ba0339698",
        "storage_key": "property/6737460151191756/01a06832-0450-73ff-8d98-993ba0339698.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience modern living in this open-concept apartment, featuring vaulted ceilings and a seamless flow from the living area to a well-appointed kitchen.",
      "link": "",
      "alt_text": "Spacious living area with vaulted ceilings, a ceiling fan, and an open view to the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1953ad61-0825-4ce2-8a40-8b8896f825bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-0490-724e-bbe6-543719ffba08.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with granite countertop, white sink, and mirror reflecting a bedroom.",
        "public_id": "01a06832-0490-724e-bbe6-543719ffba08",
        "storage_key": "property/6737460151191756/01a06832-0490-724e-bbe6-543719ffba08.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "This spacious bathroom features a modern vanity with a granite countertop and a large mirror. The adjoining bedroom is visible through an open doorway.",
      "link": "",
      "alt_text": "Bathroom vanity with granite countertop, white sink, and mirror reflecting a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e4e3063c-1981-4309-a4cb-4c369e2e1b39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-0181-70c7-8dd7-7a9c52ccad8e.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, stationary bikes, and weight machines.",
        "public_id": "01a06832-0181-70c7-8dd7-7a9c52ccad8e",
        "storage_key": "property/6737460151191756/01a06832-0181-70c7-8dd7-7a9c52ccad8e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with a wide range of cardio and strength training equipment to help you stay active and healthy.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, stationary bikes, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4da148f8-9cc5-4c00-acc1-7dcc24720f80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/01a06832-012e-7771-ac30-b81ba0e5b43d.webp",
      "image_media": {
        "alt_text": "Indoor basketball court with a basketball hoop and a rack of basketballs.",
        "public_id": "01a06832-012e-7771-ac30-b81ba0e5b43d",
        "storage_key": "property/6737460151191756/01a06832-012e-7771-ac30-b81ba0e5b43d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a game of basketball on our indoor court. Perfect for staying active year-round.",
      "link": "",
      "alt_text": "Indoor basketball court with a basketball hoop and a rack of basketballs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c89c050d-ad2f-4525-83d7-22d79329159c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-8689-74ff-8d2b-ed9d31030ce3.webp",
      "image_media": {
        "alt_text": "Apartment building with a large outdoor swimming pool and lounge chairs.",
        "public_id": "019e60ef-8689-74ff-8d2b-ed9d31030ce3",
        "storage_key": "property/6737460151191756/019e60ef-8689-74ff-8d2b-ed9d31030ce3.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the sparkling outdoor pool at our apartment community. Plenty of lounge chairs available for ultimate relaxation.",
      "link": "",
      "alt_text": "Apartment building with a large outdoor swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0528fe3-7ea4-4a43-939b-f89cffe7e00b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-6563-70aa-89dd-25912d1a7317.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, armchair, and decorative accents.",
        "public_id": "019e60ef-6563-70aa-89dd-25912d1a7317",
        "storage_key": "property/6737460151191756/019e60ef-6563-70aa-89dd-25912d1a7317.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sectional sofa, a modern coffee table, and an armchair, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, armchair, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29575155-5a95-48bb-8ad0-e02d931dba08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-6211-752d-b7ce-6810e478f217.webp",
      "image_media": {
        "alt_text": "Neutral-toned bedroom with a king-size bed, nightstands, and a ceiling fan.",
        "public_id": "019e60ef-6211-752d-b7ce-6810e478f217",
        "storage_key": "property/6737460151191756/019e60ef-6211-752d-b7ce-6810e478f217.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable king-size bed, modern nightstands with lamps, and a ceiling fan for added comfort.",
      "link": "",
      "alt_text": "Neutral-toned bedroom with a king-size bed, nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b8ea098-6e88-43f6-ad40-5ab06907d2c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-74f3-77e3-a053-151f09d1f00b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019e60ef-74f3-77e3-a053-151f09d1f00b",
        "storage_key": "property/6737460151191756/019e60ef-74f3-77e3-a053-151f09d1f00b.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space for all your storage needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c1f47cfb-11f9-4c4a-bce0-d4653bebae69",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-87db-77a8-aa8d-c2bc3150a4a7.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with grills and dining tables.",
        "public_id": "019e60ef-87db-77a8-aa8d-c2bc3150a4a7",
        "storage_key": "property/6737460151191756/019e60ef-87db-77a8-aa8d-c2bc3150a4a7.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy the outdoors with comfortable seating, grilling stations, and dining areas perfect for entertaining.",
      "link": "",
      "alt_text": "Outdoor seating area with grills and dining tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f491cba6-3807-42b6-8305-9ceafa6a43e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-8388-7784-9c94-32f958c237f4.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs surrounding it, with apartment buildings in the background.",
        "public_id": "019e60ef-8388-7784-9c94-32f958c237f4",
        "storage_key": "property/6737460151191756/019e60ef-8388-7784-9c94-32f958c237f4.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax by our stunning outdoor swimming pool, perfect for a refreshing dip or lounging in the sun. Enjoy the resort-style amenities at our community.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs surrounding it, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_58430e5e-3b5e-4902-9332-476ecf717d87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-84fb-7181-a0f0-0f82f484827e.webp",
      "image_media": {
        "alt_text": "Community game room with foosball and shuffleboard tables.",
        "public_id": "019e60ef-84fb-7181-a0f0-0f82f484827e",
        "storage_key": "property/6737460151191756/019e60ef-84fb-7181-a0f0-0f82f484827e.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy fun and games in our resident game room, featuring foosball, shuffleboard, and a billiards table.",
      "link": "",
      "alt_text": "Community game room with foosball and shuffleboard tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_18e45a73-be69-4025-af16-2685d7a4c93b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-70e4-75ad-8af2-c32cafad5688.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, accent chair, and decorative cabinet.",
        "public_id": "019e60ef-70e4-75ad-8af2-c32cafad5688",
        "storage_key": "property/6737460151191756/019e60ef-70e4-75ad-8af2-c32cafad5688.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, a modern coffee table, and a decorative cabinet, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, coffee table, accent chair, and decorative cabinet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36ae4f39-ece2-4a44-8479-d2e718dcb885",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e60ef-635b-74e7-bbf5-1a8537c84409.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark wood vanity, granite countertop, and white tile tub/shower.",
        "public_id": "019e60ef-635b-74e7-bbf5-1a8537c84409",
        "storage_key": "property/6737460151191756/019e60ef-635b-74e7-bbf5-1a8537c84409.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Step into this updated bathroom featuring a spacious vanity with granite countertops, a large mirror with vanity lighting, and a clean white tile tub/shower combination.",
      "link": "",
      "alt_text": "Modern bathroom with dark wood vanity, granite countertop, and white tile tub/shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_76055df9-2ebb-4749-93c0-20368e83e68f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Oven & Tap",
      "poi_type": "Restaurants",
      "poi_address": "215 S Main St #3, Bentonville, AR 72712, USA",
      "poi_short_description": "Relaxed place for wood-fired pizzas, sandwiches & Southern-inspired fare, plus a bar & craft beer.",
      "poi_long_description": "Relaxed place for wood-fired pizzas, sandwiches & Southern-inspired fare, plus a bar & craft beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-d7d4-7635-97ce-32ca9dddc771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-d7d4-7635-97ce-32ca9dddc771",
        "storage_key": "property/6737460151191756/019e1e45-d7d4-7635-97ce-32ca9dddc771.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ovenandtap.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3056518514706659080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oven--tap",
      "poi_latitude": "36.3709528",
      "poi_longitude": "-94.2082972",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-268-5884",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmwqSnJkayYcRCLd-HmXvaio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0b1e0eb2-9bc3-4ad7-aeee-09ad0994405f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Tusk & Trotter American Brasserie Bentonville",
      "poi_type": "Restaurants",
      "poi_address": "110 SE A St, Bentonville, AR 72712, USA",
      "poi_short_description": "Gastropub offering a locally sourced, seasonal menu & craft beers in a casual, rustic-chic setting.",
      "poi_long_description": "Gastropub offering a locally sourced, seasonal menu & craft beers in a casual, rustic-chic setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-dc92-73e8-9b5d-d82cc1688199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-dc92-73e8-9b5d-d82cc1688199",
        "storage_key": "property/6737460151191756/019e1e45-dc92-73e8-9b5d-d82cc1688199.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.tuskandtrotter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12737255311578484512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tusk--trotter-american-brasserie-bentonville",
      "poi_latitude": "36.3715819",
      "poi_longitude": "-94.208313",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 479-268-4494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9oijpkayYcRIM8XlDjSw7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_348bc29d-630f-44df-853a-03d863669dc2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "The Preacher's Son",
      "poi_type": "Restaurants",
      "poi_address": "201 NW A St, Bentonville, AR 72712, USA",
      "poi_short_description": "Refined New American plates in the serene atmosphere of a restored Gothic Revival church.",
      "poi_long_description": "Refined New American plates in the serene atmosphere of a restored Gothic Revival church.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-dc41-71e1-8820-de95d43b7e8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-dc41-71e1-8820-de95d43b7e8c",
        "storage_key": "property/6737460151191756/019e1e45-dc41-71e1-8820-de95d43b7e8c.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://www.thepreachersson.com/?y_source=1_MjAzNDAxNzk1MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10152112371664247505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-preachers-son",
      "poi_latitude": "36.3731948",
      "poi_longitude": "-94.2104842",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-445-6065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy047K5gayYcR0Vrl8GmM44w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_aac0516f-73e5-4030-9204-956ddef9418b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "The Hive",
      "poi_type": "Restaurants",
      "poi_address": "200 NE A St, Bentonville, AR 72712, USA",
      "poi_short_description": "Elevated, locally sourced Arkansas fare served within the sleek, modern 21c Museum Hotel.",
      "poi_long_description": "Elevated, locally sourced Arkansas fare served within the sleek, modern 21c Museum Hotel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-d66e-7401-afa1-80326f08df19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-d66e-7401-afa1-80326f08df19",
        "storage_key": "property/6737460151191756/019e1e45-d66e-7401-afa1-80326f08df19.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.thehivebentonville.com/menu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6854281461056587573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hive",
      "poi_latitude": "36.3739649",
      "poi_longitude": "-94.2078824",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-286-6575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_rw-5kayYcRNcfSXKxMH18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_90b738ed-1f5e-4382-aa18-09af98a1ca88",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Eleven at Crystal Bridges",
      "poi_type": "Restaurants",
      "poi_address": "600 Museum Way, Bentonville, AR 72712, USA",
      "poi_short_description": "Stylish cafe with a sweeping wooden roof & large windows for a selection of local, sustainable grub.",
      "poi_long_description": "Stylish cafe with a sweeping wooden roof & large windows for a selection of local, sustainable grub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-de81-75de-9061-1ca4ddbe7ceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-de81-75de-9061-1ca4ddbe7ceb",
        "storage_key": "property/6737460151191756/019e1e45-de81-75de-9061-1ca4ddbe7ceb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://crystalbridges.org/eleven/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15138887541013917946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eleven-at-crystal-bridges",
      "poi_latitude": "36.38215770000001",
      "poi_longitude": "-94.2034698",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 479-418-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ08zth5IayYcR-rC4YAIiGNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_cda5c8aa-b7d7-4a44-93c7-cd7356db33fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Mezzaluna Pasteria & Mozzarella Bar Bentonville",
      "poi_type": "Restaurants",
      "poi_address": "215 NW A St suite 140, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-dd48-758c-8d5a-6241c041ff44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-dd48-758c-8d5a-6241c041ff44",
        "storage_key": "property/6737460151191756/019e1e45-dd48-758c-8d5a-6241c041ff44.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mezzalunapasteria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14726202214472886515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mezzaluna-pasteria--mozzarella-bar-bentonville",
      "poi_latitude": "36.3738679",
      "poi_longitude": "-94.2102826",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 479-520-8435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuas1XwAbyYcR8yg6LOT6Xcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_0e995679-64a9-4f9b-8fd3-acefe45974fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Junto",
      "poi_type": "Restaurants",
      "poi_address": "229 S Main St Suite 100, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-d77f-71ce-8087-531ec1595e9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-d77f-71ce-8087-531ec1595e9a",
        "storage_key": "property/6737460151191756/019e1e45-d77f-71ce-8087-531ec1595e9a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.juntosushi.com/?y_source=1_MTA2NTE0NDI3NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13582055177074627016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "junto",
      "poi_latitude": "36.3704657",
      "poi_longitude": "-94.2087106",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-345-5005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfS6G8UcbyYcRyNFJBTknfbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_b3a9ca31-367b-4173-a481-c5e595d71f9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Brothers Meethouse",
      "poi_type": "Restaurants",
      "poi_address": "405 SE 5th St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-dc98-767d-827a-5d96f5f3dc31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-dc98-767d-827a-5d96f5f3dc31",
        "storage_key": "property/6737460151191756/019e1e45-dc98-767d-827a-5d96f5f3dc31.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.brothersmeethouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2347092551770160000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brothers-meethouse",
      "poi_latitude": "36.36792459999999",
      "poi_longitude": "-94.2033099",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 479-553-7199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_-eNwAbyYcRgLs5iz2MkiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_50800929-35af-4d1c-a80a-714c6c9c877b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Onyx Coffee Lab",
      "poi_type": "Restaurants",
      "poi_address": "100 NW 2nd St Suite 106, Bentonville, AR 72712, USA",
      "poi_short_description": "Coffeehouse providing espresso drinks made with locally roasted, carefully sourced beans.",
      "poi_long_description": "Coffeehouse providing espresso drinks made with locally roasted, carefully sourced beans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-d82e-779a-9f9b-cbd5fd5b9c85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-d82e-779a-9f9b-cbd5fd5b9c85",
        "storage_key": "property/6737460151191756/019e1e45-d82e-779a-9f9b-cbd5fd5b9c85.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://onyxcoffeelab.com/pages/bentonville",
      "poi_directions_map_url": "https://maps.google.com/?cid=14017669312028229279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onyx-coffee-lab",
      "poi_latitude": "36.3731117",
      "poi_longitude": "-94.2092746",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-715-6492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-3446-73ba-9583-9035ae823f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-3446-73ba-9583-9035ae823f52",
        "storage_key": "property/6737460151191756/019e1e46-3446-73ba-9583-9035ae823f52.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJa00m55kayYcRnz5WcvjDiMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_33acb898-5120-4645-8e9e-c26a6908bb52",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Gold Town Sushi & Korean BBQ",
      "poi_type": "Restaurants",
      "poi_address": "1100 SE 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Counter-serve eatery offering Japanese & Korean staples like sushi, bento boxes & bibimbap.",
      "poi_long_description": "Counter-serve eatery offering Japanese & Korean staples like sushi, bento boxes & bibimbap.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-da1b-7532-ae06-f27a17ee15eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-da1b-7532-ae06-f27a17ee15eb",
        "storage_key": "property/6737460151191756/019e1e45-da1b-7532-ae06-f27a17ee15eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://goldtownbentonville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17785174444790106166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gold-town-sushi--korean-bbq",
      "poi_latitude": "36.3560091",
      "poi_longitude": "-94.1961419",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-273-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG2XLanwQyYcRNsgReu2h0fY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_barbecue_restaurant"
    },
    {
      "id": "custom_b293aaae-5f2d-4c58-9a4f-c2afe2d3e3ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Bentonville Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "901 SW 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-ded5-74e6-845f-27a0cfc747d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-ded5-74e6-845f-27a0cfc747d9",
        "storage_key": "property/6737460151191756/019e1e45-ded5-74e6-845f-27a0cfc747d9.webp",
        "width": 1000,
        "height": 553
      },
      "poi_business_url": "https://bentonvillebrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16300324017488664510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-brewing-company",
      "poi_latitude": "36.356613",
      "poi_longitude": "-94.2212277",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-903-7330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVRtR6IMayYcRvhcuwlRiNuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_4ad3d889-ee3b-4401-8069-26f89e84b4d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "The Big Lieutenant",
      "poi_type": "Restaurants",
      "poi_address": "600 SW 41st St #8, Bentonville, AR 72712, USA",
      "poi_short_description": "Neighborhood restaurant and bar in South Bentonville offering a chef-driven New American menu of comfort food for lunch and dinner.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-e2bf-76c9-8ad0-b5de0138595f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-e2bf-76c9-8ad0-b5de0138595f",
        "storage_key": "property/6737460151191756/019e1e45-e2bf-76c9-8ad0-b5de0138595f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebiglieutenant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5426596426267513286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-big-lieutenant",
      "poi_latitude": "36.3312199",
      "poi_longitude": "-94.2222115",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-332-4318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-7fWTuQRyYcRxlEUx7IkT0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_27653779-5c9b-41e8-868c-8b239c624c83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Las Fajitas Bentonville #2 - Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2003 SW Regional Airport Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Relaxed option for a range of Mexican eats, including tacos and burritos, plus delivery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-e286-77e2-af55-3512759478ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-e286-77e2-af55-3512759478ba",
        "storage_key": "property/6737460151191756/019e1e45-e286-77e2-af55-3512759478ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lasfajitasrestaurants.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9668312906472270790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-fajitas-bentonville-2---mexican-restaurant",
      "poi_latitude": "36.3355868",
      "poi_longitude": "-94.2373185",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-657-2594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1ncxt4PyYcRxquaD12_LIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_edbec2e2-a9c0-4107-b488-d28ac58efa4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Bella's Table",
      "poi_type": "Restaurants",
      "poi_address": "638 W Lancashire Blvd, Bella Vista, AR 72715, USA",
      "poi_short_description": "Calamari, risotto, and other Italian eats served in a contemporary space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-e324-747c-a497-dde1fcfed0c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-e324-747c-a497-dde1fcfed0c2",
        "storage_key": "property/6737460151191756/019e1e45-e324-747c-a497-dde1fcfed0c2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bellastable.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6168480664547336416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellas-table",
      "poi_latitude": "36.4557344",
      "poi_longitude": "-94.2904579",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 479-367-2509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SaFHx4DyYcR4KA1fnvYmlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_450f1d8c-4ee3-4bde-8fee-503c01df162d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Slim Chickens",
      "poi_type": "Restaurants",
      "poi_address": "1000 SW Regional Airport Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Counter-serve chain specializing in chicken dishes, plus Southern sides & desserts served in jars.",
      "poi_long_description": "Counter-serve chain specializing in chicken dishes, plus Southern sides & desserts served in jars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-e718-77db-9d8d-caf2341b1594.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-e718-77db-9d8d-caf2341b1594",
        "storage_key": "property/6737460151191756/019e1e45-e718-77db-9d8d-caf2341b1594.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://slimchickens.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11212328051316505337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slim-chickens",
      "poi_latitude": "36.3361",
      "poi_longitude": "-94.22437",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 479-802-4188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLR18BvkRyYcR-TreC_Uwmps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_ed55fbe6-7b53-4214-9906-08face53ca9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "906 SW Regional Airport Blvd, Bentonville, AR 72713, USA",
      "poi_short_description": "Chain of grocery stores carrying baked goods, electronics, clothing and other household items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-6b8c-710a-aa98-54333cabbbdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e43-6b8c-710a-aa98-54333cabbbdf",
        "storage_key": "property/6737460151191756/019e1e43-6b8c-710a-aa98-54333cabbbdf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/4686-bentonville-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570164248636695790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.3371876",
      "poi_longitude": "-94.2239398",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-268-7678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8fcb-71fb-a606-f83b69348c88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8fcb-71fb-a606-f83b69348c88",
        "storage_key": "property/6737460151191756/019e1e43-8fcb-71fb-a606-f83b69348c88.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB30C4yIQyYcR7iR6zuNVFNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b31515d4-affc-4302-80af-3b87a0edfce9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1006 SW 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-6d16-7598-aa41-7ba121ef5904.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e43-6d16-7598-aa41-7ba121ef5904",
        "storage_key": "property/6737460151191756/019e1e43-6d16-7598-aa41-7ba121ef5904.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ar/bentonville/1006-sw-14th-street/f289",
      "poi_directions_map_url": "https://maps.google.com/?cid=11311701847499853259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.357874",
      "poi_longitude": "-94.224048",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8fcb-71fb-a606-f83b69348c88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8fcb-71fb-a606-f83b69348c88",
        "storage_key": "property/6737460151191756/019e1e43-8fcb-71fb-a606-f83b69348c88.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ026o7fkRyYcRy81b-eU8-5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8b8aa993-bbf6-4d19-b723-0d77c3c82864",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Live + Well Pharmacy - Bentonville",
      "poi_type": "Shopping & Retail",
      "poi_address": "3500 SW Regional Airport Blvd #2, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-e95e-75ac-af3b-e48531ec9477.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-e95e-75ac-af3b-e48531ec9477",
        "storage_key": "property/6737460151191756/019e1e45-e95e-75ac-af3b-e48531ec9477.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.livewellrxlab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4310982767815549264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "live--well-pharmacy---bentonville",
      "poi_latitude": "36.3366317",
      "poi_longitude": "-94.2520422",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 479-271-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-3445-729c-bec6-128f66dbb156.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-3445-729c-bec6-128f66dbb156",
        "storage_key": "property/6737460151191756/019e1e46-3445-729c-bec6-128f66dbb156.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3EpxWYPyYcRUOF5nPyv0zs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9f4b4217-9f9f-4bd5-866d-a7da9f5724f0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Star Liquor Bentonville Airport Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "7403 SW Regional Airport Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Liquor store offering a wide selection of beer, wine, vodka, and other spirits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-e977-763d-94f7-c84a8565f110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-e977-763d-94f7-c84a8565f110",
        "storage_key": "property/6737460151191756/019e1e45-e977-763d-94f7-c84a8565f110.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Star-Liquor-371236673004183/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4504267100656989516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-liquor-bentonville-airport-plaza",
      "poi_latitude": "36.3146492",
      "poi_longitude": "-94.2941928",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 479-224-6327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f2b-7400-82b4-04070c138068.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f2b-7400-82b4-04070c138068",
        "storage_key": "property/6737460151191756/019e1e43-8f2b-7400-82b4-04070c138068.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMUanOeAOyYcRTHUjPBBfgj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_6c000928-d32d-49c0-a38a-47d6b0ce2230",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Maverik",
      "poi_type": "Shopping & Retail",
      "poi_address": "3610 SW Regional Airport Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Gas-station & convenience store chain, serving drinks & snacks from burritos to frozen yogurt.",
      "poi_long_description": "Gas-station & convenience store chain, serving drinks & snacks from burritos to frozen yogurt.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-e8f5-73b8-a92f-79611fcfa07d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-e8f5-73b8-a92f-79611fcfa07d",
        "storage_key": "property/6737460151191756/019e1e45-e8f5-73b8-a92f-79611fcfa07d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.maverik.com/ar/bentonville/3610-sw-regional-airport-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=12732764882362153851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maverik",
      "poi_latitude": "36.3368997",
      "poi_longitude": "-94.2535208",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 479-254-3759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-344e-767c-9dfb-ac7521b79980.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-344e-767c-9dfb-ac7521b79980",
        "storage_key": "property/6737460151191756/019e1e46-344e-767c-9dfb-ac7521b79980.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHX8cz9wPyYcRe7vDDTPes7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_302e52cc-8595-4d63-9a78-3c4d5fcbaa97",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Casey's",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 SW 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_long_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-eb05-7118-b3c6-c03e74429208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-eb05-7118-b3c6-c03e74429208",
        "storage_key": "property/6737460151191756/019e1e45-eb05-7118-b3c6-c03e74429208.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.caseys.com/general-store/ar-bentonville/900-sw-14th-st/3022?utm_medium=organic&utm_source=google&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=1304238172571829688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caseys",
      "poi_latitude": "36.3577896",
      "poi_longitude": "-94.2214531",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-464-9849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f21-73fc-9186-eb2eba429ca3",
        "storage_key": "property/6737460151191756/019e1e43-8f21-73fc-9186-eb2eba429ca3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2MctwgQyYcRuAWmMrWVGRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_5f6cec75-68fd-4ec7-a36b-f0779f318022",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "8100 SW Regional Airport Blvd, Bentonville, AR 72713, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-ec90-72ad-84dc-bc8de4dec41e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-ec90-72ad-84dc-bc8de4dec41e",
        "storage_key": "property/6737460151191756/019e1e45-ec90-72ad-84dc-bc8de4dec41e.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ar/bentonville/23820",
      "poi_directions_map_url": "https://maps.google.com/?cid=8239759990728600965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "36.3127288",
      "poi_longitude": "-94.3043518",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 479-384-5759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f2b-7400-82b4-04070c138068.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f2b-7400-82b4-04070c138068",
        "storage_key": "property/6737460151191756/019e1e43-8f2b-7400-82b4-04070c138068.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ14qfnaAPyYcRha3aMQ6CWXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_13cea2fc-498d-4d73-bce2-bbde0d7fafbf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "3500 SE Club Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-ee95-74bd-ab3c-bfd75144d3f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-ee95-74bd-ab3c-bfd75144d3f0",
        "storage_key": "property/6737460151191756/019e1e45-ee95-74bd-ab3c-bfd75144d3f0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.samsclub.com/club/4969-bentonville-ar",
      "poi_directions_map_url": "https://maps.google.com/?cid=11461601690814428863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "36.3519444",
      "poi_longitude": "-94.1713889",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 479-621-5537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f2b-7400-82b4-04070c138068.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f2b-7400-82b4-04070c138068",
        "storage_key": "property/6737460151191756/019e1e43-8f2b-7400-82b4-04070c138068.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6R_YWb0QyYcRv7YC-gLKD58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3232ec5a-2666-4d2d-80ab-65f80b796801",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "406 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Market stocking foods, produce and sundry items, along with electronics, cleaning and hardware items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-eec5-728c-bdd1-ae87257ccc3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-eec5-728c-bdd1-ae87257ccc3a",
        "storage_key": "property/6737460151191756/019e1e45-eec5-728c-bdd1-ae87257ccc3a.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/100-bentonville-ar/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9489717797594232404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.3681884",
      "poi_longitude": "-94.2242442",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-273-0060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f2b-7400-82b4-04070c138068.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f2b-7400-82b4-04070c138068",
        "storage_key": "property/6737460151191756/019e1e43-8f2b-7400-82b4-04070c138068.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA3fmOK8ayYcRVHZO6A5AsoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_56ad246c-3318-41eb-97f7-384ed17d54bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Harps Food Stores",
      "poi_type": "Shopping & Retail",
      "poi_address": "1209 N Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Grocery store chain selling fresh produce and meats from local sources, as well as featuring a bakery, a deli and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-f127-769c-ac07-b06ca84f96d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-f127-769c-ac07-b06ca84f96d7",
        "storage_key": "property/6737460151191756/019e1e45-f127-769c-ac07-b06ca84f96d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.harpsfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7362598520817777792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harps-food-stores",
      "poi_latitude": "36.3869344",
      "poi_longitude": "-94.2224888",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-273-2245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8fcb-71fb-a606-f83b69348c88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8fcb-71fb-a606-f83b69348c88",
        "storage_key": "property/6737460151191756/019e1e43-8fcb-71fb-a606-f83b69348c88.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZZE55kayYcRgPwokVg0LWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3cb0e21e-1451-469f-8d38-a5595b99a4a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Vaughn Elementary School",
      "poi_type": "Education",
      "poi_address": "5301 SW Barron Rd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-f079-732d-90b2-5dd02fd9e59a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-f079-732d-90b2-5dd02fd9e59a",
        "storage_key": "property/6737460151191756/019e1e45-f079-732d-90b2-5dd02fd9e59a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bentonvillek12.org/o/ves",
      "poi_directions_map_url": "https://maps.google.com/?cid=15389496529305207992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vaughn-elementary-school",
      "poi_latitude": "36.3220941",
      "poi_longitude": "-94.2941467",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 479-254-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMdPSvMUPyYcRuARYbY55ktU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d90ee933-1a26-4fe6-826c-7f5380204cb5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Grimsley Junior High School",
      "poi_type": "Education",
      "poi_address": "850 N Vaughn Rd, Bentonville, AR 72713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1120012034524693659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grimsley-junior-high-school",
      "poi_latitude": "36.3467224",
      "poi_longitude": "-94.3016971",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 479-360-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY8fIzXgPyYcRm8QB5gIViw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_22d9269b-810b-438f-83c5-0c6b7509992b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Bentonville West High School",
      "poi_type": "Education",
      "poi_address": "1351 Gamble Rd, Centerton, AR 72719, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-f321-75da-ae6e-a3d0a657898a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-f321-75da-ae6e-a3d0a657898a",
        "storage_key": "property/6737460151191756/019e1e45-f321-75da-ae6e-a3d0a657898a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bentonvillek12.org/o/bwhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=13267750746198628175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-west-high-school",
      "poi_latitude": "36.3775561",
      "poi_longitude": "-94.2963597",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 479-286-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPfdMlJQFyYcRT9eXEwKFILg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_15d8ed5b-5b21-4f28-9b57-156cdcf2f00f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Willowbrook Elementary School",
      "poi_type": "Education",
      "poi_address": "1800 SW Gator Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14814824237174807204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willowbrook-elementary-school",
      "poi_latitude": "36.3224601",
      "poi_longitude": "-94.2336502",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-418-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK-QLYSoQyYcRpNqmwibUmM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_10a6cbf0-cdb2-4445-bd94-ef60d74a3604",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Ardis Ann Middle School",
      "poi_type": "Education",
      "poi_address": "3400 Hwy 72 West, 101 NW Elm Tree Rd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/o/aams",
      "poi_directions_map_url": "https://maps.google.com/?cid=2848163031052629900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ardis-ann-middle-school",
      "poi_latitude": "36.371734",
      "poi_longitude": "-94.250469",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-254-5510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAZoYllwFyYcRjLdKwC-1hic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_729b4bba-3b94-404f-956b-08de8b2ee50f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Bentonville High School",
      "poi_type": "Education",
      "poi_address": "1801 SE J St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bentonvillek12.org/o/bhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=11218002166020631332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-high-school",
      "poi_latitude": "36.35172420000001",
      "poi_longitude": "-94.1954077",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-254-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD7qEvmIQyYcRJOs404hZrps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3a8b29f5-1b77-471b-893f-fd50911583bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Thaden School",
      "poi_type": "Education",
      "poi_address": "800 SE C St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-f1f0-721e-8b75-68ec1329b5ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-f1f0-721e-8b75-68ec1329b5ff",
        "storage_key": "property/6737460151191756/019e1e45-f1f0-721e-8b75-68ec1329b5ff.webp",
        "width": 1280,
        "height": 873
      },
      "poi_business_url": "http://thadenschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14693825991879989165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thaden-school",
      "poi_latitude": "36.3633159",
      "poi_longitude": "-94.2070269",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-268-5321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxSJ6JnYQyYcRrZdobeP06ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1fc28e76-6749-4e19-ac6c-da1bcc2e7971",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Posh Tot Learning Academy",
      "poi_type": "Education",
      "poi_address": "2000 SE 14th St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-0aa8-74fa-bb75-31ce8d471166.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-0aa8-74fa-bb75-31ce8d471166",
        "storage_key": "property/6737460151191756/019e1e46-0aa8-74fa-bb75-31ce8d471166.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://poshtotlearningacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1765367039225161548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "posh-tot-learning-academy",
      "poi_latitude": "36.3562976",
      "poi_longitude": "-94.1882686",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-268-6609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvSpJlIYQyYcRTOcyB_jXfxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_002100b7-0b3b-4925-a125-97c82411e5eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Little Martians Learning Center - Bentonville",
      "poi_type": "Education",
      "poi_address": "2306 SW D St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-f894-7778-969c-fa965a53c896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-f894-7778-969c-fa965a53c896",
        "storage_key": "property/6737460151191756/019e1e45-f894-7778-969c-fa965a53c896.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "http://littlemartianslc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7565717728975406988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-martians-learning-center---bentonville",
      "poi_latitude": "36.3468044",
      "poi_longitude": "-94.2153615",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-553-7289",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzYKK3PIRyYcRjEd0ijDU_mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_44550569-9f3c-496d-89a3-008b1a473ced",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "The Momentary",
      "poi_type": "Entertainment",
      "poi_address": "507 SE E St, Bentonville, AR 72712, USA",
      "poi_short_description": "Free-admission extension of the Crystal Bridges Museum focusing on contemporary art and live music.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-f8a2-7054-9b11-fbf76ca64e03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-f8a2-7054-9b11-fbf76ca64e03",
        "storage_key": "property/6737460151191756/019e1e45-f8a2-7054-9b11-fbf76ca64e03.webp",
        "width": 836,
        "height": 627
      },
      "poi_business_url": "https://themomentary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2949730782627288492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-momentary",
      "poi_latitude": "36.3665519",
      "poi_longitude": "-94.2026659",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-367-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhx-8ypwayYcRrNWIuYSM7yg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_75902aca-55b2-46b8-af77-f974d2ecbfb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Scott Family Amazeum",
      "poi_type": "Entertainment",
      "poi_address": "1009 Museum Way, Bentonville, AR 72712, USA",
      "poi_short_description": "Modern children's museum offering dynamic, hands-on displays & activities & an outdoor \"playscape.\"",
      "poi_long_description": "Modern children's museum offering dynamic, hands-on displays & activities & an outdoor \"playscape.\"",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-fba9-7251-9308-dc5e5545523a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-fba9-7251-9308-dc5e5545523a",
        "storage_key": "property/6737460151191756/019e1e45-fba9-7251-9308-dc5e5545523a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.amazeum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3620504812667872326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scott-family-amazeum",
      "poi_latitude": "36.3792428",
      "poi_longitude": "-94.1972494",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 479-696-9280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8fbe-742a-96fc-b6b929d3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8fbe-742a-96fc-b6b929d3f867",
        "storage_key": "property/6737460151191756/019e1e43-8fbe-742a-96fc-b6b929d3f867.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJUcoHrI4ayYcRRiSp4vGdPjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_227b35be-e81b-444d-80dc-8c98ea0c2718",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Skylight Cinema",
      "poi_type": "Entertainment",
      "poi_address": "350 SW A St, Bentonville, AR 72712, USA",
      "poi_short_description": "Cozy cinema featuring first-run & indie films, plus reclining seats & bar food during screenings.",
      "poi_long_description": "Cozy cinema featuring first-run & indie films, plus reclining seats & bar food during screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-fbd7-77f5-b73d-dbeaccd0d0cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-fbd7-77f5-b73d-dbeaccd0d0cf",
        "storage_key": "property/6737460151191756/019e1e45-fbd7-77f5-b73d-dbeaccd0d0cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.skylightcinemas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1476082750597154647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skylight-cinema",
      "poi_latitude": "36.3684385",
      "poi_longitude": "-94.2106679",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-367-7629",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-3452-763e-89df-ca860439e963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-3452-763e-89df-ca860439e963",
        "storage_key": "property/6737460151191756/019e1e46-3452-763e-89df-ca860439e963.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30y10JgayYcRV8ds6HAZfBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_767cd71e-78fb-4833-8f84-5aea4b7301d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "21c Museum Hotel Bentonville",
      "poi_type": "Entertainment",
      "poi_address": "200 NE A St, Bentonville, AR 72712, USA",
      "poi_short_description": "Hip lodging inside a contemporary art museum, plus a gym, loaner bikes & a gourmet restaurant/bar.",
      "poi_long_description": "Hip lodging inside a contemporary art museum, plus a gym, loaner bikes & a gourmet restaurant/bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-fbe1-75d9-b3c6-a004743411dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-fbe1-75d9-b3c6-a004743411dd",
        "storage_key": "property/6737460151191756/019e1e45-fbe1-75d9-b3c6-a004743411dd.webp",
        "width": 1280,
        "height": 845
      },
      "poi_business_url": "https://www.21cmuseumhotels.com/bentonville?utm_source=google&utm_medium=organic&utm_campaign=gmb-website&utm_content=website_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=2168657143112449453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "21c-museum-hotel-bentonville",
      "poi_latitude": "36.3740903",
      "poi_longitude": "-94.2078794",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-286-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-346e-727c-9288-1cc2d85f54f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-346e-727c-9288-1cc2d85f54f2",
        "storage_key": "property/6737460151191756/019e1e46-346e-727c-9288-1cc2d85f54f2.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJtQtoTZcayYcRrb3Ufi6eGB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_dae3d355-f10d-4bc5-93db-4d25f7fa28a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Meteor Guitar Gallery",
      "poi_type": "Entertainment",
      "poi_address": "128 W Central Ave, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-fcdf-70a4-a9a6-d840d542ffea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-fcdf-70a4-a9a6-d840d542ffea",
        "storage_key": "property/6737460151191756/019e1e45-fcdf-70a4-a9a6-d840d542ffea.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://meteorguitargallery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2258921327562490356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meteor-guitar-gallery",
      "poi_latitude": "36.3725874",
      "poi_longitude": "-94.209934",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-268-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVS0UzpkayYcR9IHqqPpMWR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_78899078-0049-4d8a-ab50-f6760b0c9f65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "The Walmart Museum",
      "poi_type": "Entertainment",
      "poi_address": "105 N Main St, Bentonville, AR 72712, USA",
      "poi_short_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_long_description": "Chain retailer with a vast selection including groceries, apparel, home goods & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-02d4-732e-97ce-1c62da1a43b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-02d4-732e-97ce-1c62da1a43b6",
        "storage_key": "property/6737460151191756/019e1e46-02d4-732e-97ce-1c62da1a43b6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.walmartmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5406846993405692822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-walmart-museum",
      "poi_latitude": "36.37245410000001",
      "poi_longitude": "-94.2089508",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-273-1329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8fbe-742a-96fc-b6b929d3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8fbe-742a-96fc-b6b929d3f867",
        "storage_key": "property/6737460151191756/019e1e43-8fbe-742a-96fc-b6b929d3f867.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNVzPwpkayYcRlsvVnLH6CEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_46909852-308f-40f7-a0fd-17ef1469ea7a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Peel Museum & Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "400 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Former 19th-century home now serving as a botanical garden, event venue, and museum.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-6e2f-7244-a4ab-501ac98a0bc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e43-6e2f-7244-a4ab-501ac98a0bc7",
        "storage_key": "property/6737460151191756/019e1e43-6e2f-7244-a4ab-501ac98a0bc7.webp",
        "width": 640,
        "height": 960
      },
      "poi_business_url": "https://www.peelcompton.org/peel-museum-botanical-garden/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10960123937017476129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peel-museum--botanical-garden",
      "poi_latitude": "36.3690562",
      "poi_longitude": "-94.2223038",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-273-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs5IwkqUayYcRIbQuyKYuGpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_cdc7f7bb-8ebb-4c5c-95cf-f296939a86db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "The Walmart AMP",
      "poi_type": "Entertainment",
      "poi_address": "5079 W Northgate Rd, Rogers, AR 72758, USA",
      "poi_short_description": "This sizable music venue with a range of outdoor seating options hosts many touring artists.",
      "poi_long_description": "This sizable music venue with a range of outdoor seating options hosts many touring artists.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-02e2-7337-a6f1-6b44bbc37966.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-02e2-7337-a6f1-6b44bbc37966",
        "storage_key": "property/6737460151191756/019e1e46-02e2-7337-a6f1-6b44bbc37966.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://walmartamp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4073090213928832597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-walmart-amp",
      "poi_latitude": "36.302676",
      "poi_longitude": "-94.183726",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 479-443-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYU0xw0RyYcRVQ5ZK_iFhjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_b2aba2d5-fa35-4ef5-ba33-29c9cb4ebaed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Northwest Medical Center - Bentonville",
      "poi_type": "Health and Wellness",
      "poi_address": "3000 Medical Center Pkwy, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-0e7a-70a8-9c2e-958d650cb968.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-0e7a-70a8-9c2e-958d650cb968",
        "storage_key": "property/6737460151191756/019e1e46-0e7a-70a8-9c2e-958d650cb968.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "https://www.northwesthealth.com/nmc-bentonville?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12521861175053738530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-medical-center---bentonville",
      "poi_latitude": "36.3401491",
      "poi_longitude": "-94.1912939",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-553-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-3476-747a-b552-d427c80c190d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-3476-747a-b552-d427c80c190d",
        "storage_key": "property/6737460151191756/019e1e46-3476-747a-b552-d427c80c190d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdkIQPUQyYcRImLVIWWWxq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_730c1b8d-4c07-4288-85eb-0de47b349334",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Washington Regional Urgent Care - Bentonville",
      "poi_type": "Health and Wellness",
      "poi_address": "1301 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-072a-747c-9654-31a91a5874d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-072a-747c-9654-31a91a5874d2",
        "storage_key": "property/6737460151191756/019e1e46-072a-747c-9654-31a91a5874d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urgentteam.com/locations/washington-regional-urgent-care-bentonville-ar/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7074006900970683400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-regional-urgent-care---bentonville",
      "poi_latitude": "36.3578506",
      "poi_longitude": "-94.2133293",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-367-3078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxwRUMH4RyYcRCPwE98vrK2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_23e4d16e-42d6-438c-b210-edcf85407bb6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "406 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-04af-771b-a3dc-6ee7e24de478.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-04af-771b-a3dc-6ee7e24de478",
        "storage_key": "property/6737460151191756/019e1e46-04af-771b-a3dc-6ee7e24de478.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/100-bentonville-ar/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9735889868979518511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "36.3680468",
      "poi_longitude": "-94.2250057",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 479-273-5080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-3445-729c-bec6-128f66dbb156.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-3445-729c-bec6-128f66dbb156",
        "storage_key": "property/6737460151191756/019e1e46-3445-729c-bec6-128f66dbb156.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3fmOK8ayYcRLzzZvEDUHIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c55de43b-7e48-4c06-ad7c-570051d00c55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1311 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-082c-7068-9517-023126f768c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-082c-7068-9517-023126f768c1",
        "storage_key": "property/6737460151191756/019e1e46-082c-7068-9517-023126f768c1.webp",
        "width": 1280,
        "height": 891
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1311+s+walton+blvd-bentonville-ar-72712/id=16021",
      "poi_directions_map_url": "https://maps.google.com/?cid=4100844392678524795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.357476",
      "poi_longitude": "-94.2125239",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-268-7979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJszouW8YayYcRe4fBeD8g6Tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_ffc5be75-11f1-40f6-b970-6227fe32df2e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1001 SW Westpark Dr, Bentonville, AR 72712, USA",
      "poi_short_description": "Chain fitness center offering a non-intimidating environment, tanning, and massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-71d0-76c0-88fb-0e44076c13c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e43-71d0-76c0-88fb-0e44076c13c7",
        "storage_key": "property/6737460151191756/019e1e43-71d0-76c0-88fb-0e44076c13c7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/bentonville-ar?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17093251464599536686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.3585652",
      "poi_longitude": "-94.2225918",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 479-255-5756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwee1LQYQyYcRLoTho6RtN-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ae260898-c3a3-4179-be46-f69a13b65578",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "FS8 Bentonville",
      "poi_type": "Health and Wellness",
      "poi_address": "1104 S Walton Blvd Suite 2, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-0c19-7528-a005-6a7199671d7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-0c19-7528-a005-6a7199671d7d",
        "storage_key": "property/6737460151191756/019e1e46-0c19-7528-a005-6a7199671d7d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://fs8.com/studio/bentonville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15505282219533300716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fs8-bentonville",
      "poi_latitude": "36.3599",
      "poi_longitude": "-94.2164289",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-378-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbXyOLyMRyYcR7HN2NQfULdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2b96220b-9774-417c-85a6-024ba41e6b25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Yoga Story Bentonville",
      "poi_type": "Health and Wellness",
      "poi_address": "110 NW 2nd St suite 100, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-1012-777a-851f-86ee05b73e30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-1012-777a-851f-86ee05b73e30",
        "storage_key": "property/6737460151191756/019e1e46-1012-777a-851f-86ee05b73e30.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.yogastory.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13259202920829503134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga-story-bentonville",
      "poi_latitude": "36.3730773",
      "poi_longitude": "-94.2096825",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-321-4132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDSRUkJkayYcRnkbdZM4mArg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_3acebe66-1ee0-4efd-a6cb-ae85f97c483a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "HOTWORX - Bentonville, AR - Walton",
      "poi_type": "Health and Wellness",
      "poi_address": "1702 S Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-0ee5-714a-8c4b-8a8f12ba68c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-0ee5-714a-8c4b-8a8f12ba68c8",
        "storage_key": "property/6737460151191756/019e1e46-0ee5-714a-8c4b-8a8f12ba68c8.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/bentonville-walton?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14147989075818023311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---bentonville-ar---walton",
      "poi_latitude": "36.3538912",
      "poi_longitude": "-94.211953",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-367-2760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJacNEfg4RyYcRj4k97hrBV8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_a99ee779-7926-4efa-b21b-5952e83f8b5a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Bentonville Tigers Athletic Complex",
      "poi_type": "Health and Wellness",
      "poi_address": "Tiger Stadium, 1702 SE J St, Bentonville, AR 72712, USA",
      "poi_short_description": "High school athletic venue with a stadium.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-127a-739b-b18f-2d9deda60dae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-127a-739b-b18f-2d9deda60dae",
        "storage_key": "property/6737460151191756/019e1e46-127a-739b-b18f-2d9deda60dae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bentonvillek12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8597046583887787418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-tigers-athletic-complex",
      "poi_latitude": "36.3538732",
      "poi_longitude": "-94.198023",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 479-254-5170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0senHwQyYcRmvUdplHYTnc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_b5efcae9-4a4e-4794-9a7d-f07c7deb10fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Coler Mountain Bike Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 NW 3rd St, Bentonville, AR 72712, USA",
      "poi_short_description": "Relaxed, 340-acre mountain bike preserve with miles of trails, plus a playground, a cafeand camping.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-7878-7006-97dd-de1a70d4ac80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e43-7878-7006-97dd-de1a70d4ac80",
        "storage_key": "property/6737460151191756/019e1e43-7878-7006-97dd-de1a70d4ac80.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.peelcompton.org/coler-mountain-bike-preserve/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8725155075528542573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coler-mountain-bike-preserve",
      "poi_latitude": "36.3768479",
      "poi_longitude": "-94.2402353",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-507-8360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f24-74fe-a9ab-b3aa9456db0a",
        "storage_key": "property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5_LaSwFyYcRbUkTN1D6FXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_006a305f-33b8-4b5a-b686-2aac795b2496",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Slaughter Pen Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "203 NE 3rd St, Bentonville, AR 72712, USA",
      "poi_short_description": "Tail network popular among bikers, offering a variety of challenging courses in lush surrounds.",
      "poi_long_description": "Tail network popular among bikers, offering a variety of challenging courses in lush surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-13e1-71d8-8c84-01360b877ad0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-13e1-71d8-8c84-01360b877ad0",
        "storage_key": "property/6737460151191756/019e1e46-13e1-71d8-8c84-01360b877ad0.webp",
        "width": 1032,
        "height": 1280
      },
      "poi_business_url": "http://www.oztrailsnwa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15372777470547198381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slaughter-pen-trail",
      "poi_latitude": "36.375632",
      "poi_longitude": "-94.207537",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f24-74fe-a9ab-b3aa9456db0a",
        "storage_key": "property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ZVncd8ayYcRrQEYN6kTV9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_33fa0a48-1789-49f2-9efc-c64c5079a47d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Orchards Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 NE John Deshields Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Charming, spacious public park featuring a lake & fountain, open fields & a tranquil flower garden.",
      "poi_long_description": "Charming, spacious public park featuring a lake & fountain, open fields & a tranquil flower garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-184f-7118-bc24-4ede593fde8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-184f-7118-bc24-4ede593fde8f",
        "storage_key": "property/6737460151191756/019e1e46-184f-7118-bc24-4ede593fde8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bentonvillear.com/774/Orchards-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17607258738471015559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orchards-park",
      "poi_latitude": "36.3766878",
      "poi_longitude": "-94.1899323",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 479-464-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f24-74fe-a9ab-b3aa9456db0a",
        "storage_key": "property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9whzBYkayYcRhxT1DomMWfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_316a7072-29fb-41b9-8618-aeeb01be788a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Compton Gardens & Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "312 N Main St, Bentonville, AR 72712, USA",
      "poi_short_description": "Hiking and biking trails wind through these botanical gardens featuring labeled plants and benches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-023a-777a-be82-bd36107271bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-023a-777a-be82-bd36107271bb",
        "storage_key": "property/6737460151191756/019e1e46-023a-777a-be82-bd36107271bb.webp",
        "width": 800,
        "height": 504
      },
      "poi_business_url": "https://www.peelcompton.org/compton-gardens-arboretum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=970442275906507774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "compton-gardens--arboretum",
      "poi_latitude": "36.3766381",
      "poi_longitude": "-94.208183",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 479-254-3870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvYiMR5EayYcR_tNtuhu0dw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_4e812e6e-4acc-49e6-8862-c54e02cbe78e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "401 NE Martin Luther King Jr Pkwy, Bentonville, AR 72712, USA",
      "poi_short_description": "73-acre park with an Olympic-sized pool & diving pool, plus a ball field & other sports facilities.",
      "poi_long_description": "73-acre park with an Olympic-sized pool & diving pool, plus a ball field & other sports facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-1af3-76ef-bfc7-d67d4e150075.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-1af3-76ef-bfc7-d67d4e150075",
        "storage_key": "property/6737460151191756/019e1e46-1af3-76ef-bfc7-d67d4e150075.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bentonvillear.com/773/Memorial-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1539943602156584218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "36.3741091",
      "poi_longitude": "-94.1877789",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 479-464-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f24-74fe-a9ab-b3aa9456db0a",
        "storage_key": "property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHUxiUGMayYcRGr2tFIz6XhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d61bde95-8ea2-4015-91b4-d2de608a84e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Osage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 SW 16th St, Bentonville, AR 72712, USA",
      "poi_short_description": "Urban park featuring a dog park, archery and pickleball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-7927-74c9-a7b8-e6dc387327ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e43-7927-74c9-a7b8-e6dc387327ac",
        "storage_key": "property/6737460151191756/019e1e43-7927-74c9-a7b8-e6dc387327ac.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.peelcompton.org/osage-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16508715315507867151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "osage-park",
      "poi_latitude": "36.354941",
      "poi_longitude": "-94.2160107",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 479-254-3870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f24-74fe-a9ab-b3aa9456db0a",
        "storage_key": "property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK3704YsRyYcRD67lzhy9GuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2f66914e-2a20-40a5-81ed-84517152fbc8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Bark Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2400 N Walton Blvd, Bentonville, AR 72712, USA",
      "poi_short_description": "Clean fenced dog park with areas for small and large breeds, and an agility area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-1849-7530-91a8-9a5a5abf5e71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-1849-7530-91a8-9a5a5abf5e71",
        "storage_key": "property/6737460151191756/019e1e46-1849-7530-91a8-9a5a5abf5e71.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bentonvillear.com/781/Bark-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7567765367181735802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bark-park",
      "poi_latitude": "36.4033824",
      "poi_longitude": "-94.215765",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 479-464-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f24-74fe-a9ab-b3aa9456db0a",
        "storage_key": "property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ847LA98ayYcRevdedoEaBmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_827695be-c770-48f4-ac8e-9bb33d18ca92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Blowing Springs Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 Blowing Spring Rd, Bella Vista, AR 72714, USA",
      "poi_short_description": "Park offering picnic and barbecue facilities, walking trails, and mountain bike riding.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-16b9-7473-a456-0dc2a5f46bb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-16b9-7473-a456-0dc2a5f46bb1",
        "storage_key": "property/6737460151191756/019e1e46-16b9-7473-a456-0dc2a5f46bb1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://bellavistapoa.com/thingstodo/recreation/blowingspringscampgrounds/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5750145747359238251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blowing-springs-park",
      "poi_latitude": "36.441066",
      "poi_longitude": "-94.2288036",
      "poi_miles_from_property": "12.9",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 479-855-8075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f24-74fe-a9ab-b3aa9456db0a",
        "storage_key": "property/6737460151191756/019e1e43-8f24-74fe-a9ab-b3aa9456db0a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6fd0VkbyYcRawgSdhefzE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a8e7e194-e2c3-4b71-b6cd-47edbb6c76af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Northwest Arkansas National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Airport Blvd, Bentonville, AR 72713, USA",
      "poi_short_description": "Domestic airport featuring a yoga room, free WiFi, an arcade & games such as chess & checkers.",
      "poi_long_description": "Domestic airport featuring a yoga room, free WiFi, an arcade & games such as chess & checkers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-7b9b-7188-a26a-efad74f944de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e43-7b9b-7188-a26a-efad74f944de",
        "storage_key": "property/6737460151191756/019e1e43-7b9b-7188-a26a-efad74f944de.webp",
        "width": 640,
        "height": 960
      },
      "poi_business_url": "https://www.flyxna.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3592327295282605376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-arkansas-national-airport",
      "poi_latitude": "36.2805838",
      "poi_longitude": "-94.3045816",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 479-205-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f7e-75aa-b6e5-ea3d51d6f109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f7e-75aa-b6e5-ea3d51d6f109",
        "storage_key": "property/6737460151191756/019e1e43-8f7e-75aa-b6e5-ea3d51d6f109.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXPzbKUOyYcRQG1CYKSC2jE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_a4b09a51-8d7f-4f6b-a57b-5c229af4e355",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Bentonville Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2205 SW I St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-7e32-72c6-aab3-ed9eaf92b07b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e43-7e32-72c6-aab3-ed9eaf92b07b",
        "storage_key": "property/6737460151191756/019e1e43-7e32-72c6-aab3-ed9eaf92b07b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thadenfield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504987364290196130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-municipal-airport",
      "poi_latitude": "36.3457541",
      "poi_longitude": "-94.2197768",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 479-254-0817",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f7e-75aa-b6e5-ea3d51d6f109.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f7e-75aa-b6e5-ea3d51d6f109",
        "storage_key": "property/6737460151191756/019e1e43-8f7e-75aa-b6e5-ea3d51d6f109.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJOUauoRYQyYcRovKHVdekZUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3a15d985-5f9e-44db-a880-5c9d9eee85d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Bentonville Community Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 SW Citizens Cir, Bentonville, AR 72712, USA",
      "poi_short_description": "Clean community center featuring a lap pool, a kids-only pool and an outdoor playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-1cf1-758b-a1b1-cef0abed25ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-1cf1-758b-a1b1-cef0abed25ce",
        "storage_key": "property/6737460151191756/019e1e46-1cf1-758b-a1b1-cef0abed25ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bentonvillear.com/359/Community-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17378480803937372516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-community-center",
      "poi_latitude": "36.3309331",
      "poi_longitude": "-94.225257",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 479-696-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13SsDCUQyYcRZMmhTjfELPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_e766dd1b-8d30-4c20-8f3f-e686482ad5a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "NorthWest Arkansas Community College",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 College Dr, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-f6b1-768a-bab2-25572a684c6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-f6b1-768a-bab2-25572a684c6c",
        "storage_key": "property/6737460151191756/019e1e45-f6b1-768a-bab2-25572a684c6c.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://www.nwacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8062833287412958226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-arkansas-community-college",
      "poi_latitude": "36.358598",
      "poi_longitude": "-94.172471",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 479-986-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa3NSpZgQyYcREsRx-yfw5G8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5a3460cd-b898-4cf4-aaf6-fed39c63344b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Ozark Regional Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "2423 E Robinson Ave, Springdale, AR 72764, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ozark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=403391728593572087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ozark-regional-transit",
      "poi_latitude": "36.1662982",
      "poi_longitude": "-94.1041876",
      "poi_miles_from_property": "19.3",
      "poi_walking_minutes": "7 hours 9 mins",
      "poi_biking_minutes": "2 hours 14 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 479-756-5901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyfVTTwBryYcR95Am0KMimQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_db2a935b-c2b5-43f3-8728-8dc481855c72",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Bentonville City Hall",
      "poi_type": "Transportation & Transit",
      "poi_address": "305 SW A St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-1e87-708f-87ff-90140801347b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-1e87-708f-87ff-90140801347b",
        "storage_key": "property/6737460151191756/019e1e46-1e87-708f-87ff-90140801347b.webp",
        "width": 543,
        "height": 337
      },
      "poi_business_url": "http://www.bentonvillear.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4425440534272238391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bentonville-city-hall",
      "poi_latitude": "36.3688061",
      "poi_longitude": "-94.2100228",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-271-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-3473-7738-8121-9321ea70498a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-3473-7738-8121-9321ea70498a",
        "storage_key": "property/6737460151191756/019e1e46-3473-7738-8121-9321ea70498a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9e7vyJkayYcRN2PpC7hSaj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_d6df98f3-fbd2-42fc-9b57-01a41556809a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Walmart Home Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1110 SE 10th St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-242d-741e-88fa-b5e028fd8dd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-242d-741e-88fa-b5e028fd8dd2",
        "storage_key": "property/6737460151191756/019e1e46-242d-741e-88fa-b5e028fd8dd2.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://corporate.walmart.com/about/newhomeoffice",
      "poi_directions_map_url": "https://maps.google.com/?cid=9118970850557842883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-home-office",
      "poi_latitude": "36.3592345",
      "poi_longitude": "-94.1940421",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWvlQQARyYcRw1WkmKwXjX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_238313c3-f9c1-4c52-bbe2-9063c03bde7a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Sam's Club Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 SE Simple Savings Dr #2101, Bentonville, AR 72712, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-24d8-70da-9e0b-3724e6a5b26d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-24d8-70da-9e0b-3724e6a5b26d",
        "storage_key": "property/6737460151191756/019e1e46-24d8-70da-9e0b-3724e6a5b26d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/bentonville-ar-sams-club/6214",
      "poi_directions_map_url": "https://maps.google.com/?cid=2386529284113169375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club-headquarters",
      "poi_latitude": "36.3459593",
      "poi_longitude": "-94.1867553",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 479-273-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqD4wQyYcR3_uhUb2nHiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3ead25d0-5ebc-4d82-8bcd-6cdf1f1d9fa7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Crystal Bridges Museum of American Art",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 Museum Way, Bentonville, AR 72712, USA",
      "poi_short_description": "Renowned collection ranging from Rockwell to Warhol in a striking structure set on 120 lush acres.",
      "poi_long_description": "Renowned collection ranging from Rockwell to Warhol in a striking structure set on 120 lush acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e45-f651-71e8-97f7-006b460a0dd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e45-f651-71e8-97f7-006b460a0dd5",
        "storage_key": "property/6737460151191756/019e1e45-f651-71e8-97f7-006b460a0dd5.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://crystalbridges.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12476663502294684731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crystal-bridges-museum-of-american-art",
      "poi_latitude": "36.3818542",
      "poi_longitude": "-94.2026525",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 479-418-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8fbe-742a-96fc-b6b929d3f867.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8fbe-742a-96fc-b6b929d3f867",
        "storage_key": "property/6737460151191756/019e1e43-8fbe-742a-96fc-b6b929d3f867.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5IzxBQayYcROxRb5FkDJq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_b39a3d0a-d903-48ee-bc2f-ed7e7828a455",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Arkansas Children's Northwest Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2601 S Gene George Blvd, Springdale, AR 72762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-2467-75f8-b1df-ef25d3a329b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-2467-75f8-b1df-ef25d3a329b4",
        "storage_key": "property/6737460151191756/019e1e46-2467-75f8-b1df-ef25d3a329b4.webp",
        "width": 718,
        "height": 404
      },
      "poi_business_url": "https://www.archildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3684343552893161194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-childrens-northwest-hospital",
      "poi_latitude": "36.162254",
      "poi_longitude": "-94.1903619",
      "poi_miles_from_property": "14.9",
      "poi_walking_minutes": "5 hours 29 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 479-309-5391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-3476-747a-b552-d427c80c190d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-3476-747a-b552-d427c80c190d",
        "storage_key": "property/6737460151191756/019e1e46-3476-747a-b552-d427c80c190d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJXS06JeJsyYcR6o6y3PBqITM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_225beb1e-8426-43a5-b1ff-5062f6b2e040",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Mercy Hospital Northwest Arkansas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2710 S Rife Medical Ln, Rogers, AR 72758, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-2588-714e-ab47-122cce49cb62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-2588-714e-ab47-122cce49cb62",
        "storage_key": "property/6737460151191756/019e1e46-2588-714e-ab47-122cce49cb62.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-northwest-arkansas?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=Central&utm_content=website&y_source=1_MTI5OTY0NzItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=6342883712185739120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercy-hospital-northwest-arkansas",
      "poi_latitude": "36.3092179",
      "poi_longitude": "-94.1829407",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 479-338-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-3476-747a-b552-d427c80c190d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e46-3476-747a-b552-d427c80c190d",
        "storage_key": "property/6737460151191756/019e1e46-3476-747a-b552-d427c80c190d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ60dIRQURyYcRcCdxVCFzBlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_472ddefb-9ad6-4bc4-bf22-0802426c6c0c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Tyson Foods World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2200 W Don Tyson Pkwy, Springdale, AR 72762, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-2918-737c-bac7-9973df63dbe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-2918-737c-bac7-9973df63dbe2",
        "storage_key": "property/6737460151191756/019e1e46-2918-737c-bac7-9973df63dbe2.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://www.tysonfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16323102854454874636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyson-foods-world-headquarters",
      "poi_latitude": "36.1546202",
      "poi_longitude": "-94.1541342",
      "poi_miles_from_property": "17.3",
      "poi_walking_minutes": "6 hours 22 mins",
      "poi_biking_minutes": "2 hours 6 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 800-643-3410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QqgXhdryYcRDJLyB5BPh-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0213f999-bb57-4b12-bbb1-557325f2dc26",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "J.B. Hunt Transport Services, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "615 JB Hunt Corporate Dr, Lowell, AR 72745, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-2647-70ff-a93c-d302e2854669.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-2647-70ff-a93c-d302e2854669",
        "storage_key": "property/6737460151191756/019e1e46-2647-70ff-a93c-d302e2854669.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jbhunt.com/?utm_source=GoogleMyBusiness&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=11570535468398063576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jb-hunt-transport-services-inc",
      "poi_latitude": "36.2447313",
      "poi_longitude": "-94.1494438",
      "poi_miles_from_property": "13.7",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 479-820-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9YjK4HkUyYcR2K_shrTMkqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_c98ef43c-393f-402b-b9c0-b778c25c2906",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "University of Arkansas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Fayetteville, AR 72701, USA",
      "poi_short_description": "This 1871 research university offers over 3 miles of sidewalk imprinted with the names of graduates.",
      "poi_long_description": "This 1871 research university offers over 3 miles of sidewalk imprinted with the names of graduates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-2b1f-714d-91f2-cabf11bd51b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-2b1f-714d-91f2-cabf11bd51b1",
        "storage_key": "property/6737460151191756/019e1e46-2b1f-714d-91f2-cabf11bd51b1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.uark.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1198794484653892455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas",
      "poi_latitude": "36.0686895",
      "poi_longitude": "-94.1748471",
      "poi_miles_from_property": "21.2",
      "poi_walking_minutes": "7 hours 51 mins",
      "poi_biking_minutes": "3 hours 3 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "+1 479-575-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f07-77aa-b8d5-0a2c3a385f99",
        "storage_key": "property/6737460151191756/019e1e43-8f07-77aa-b8d5-0a2c3a385f99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL_bwEOZuyYcRZyN-eDv5ohA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_feaac1ce-2b3e-4cb7-841d-81f6e9a1b848",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "poi_name": "Walton Family Foundation Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "215 NW A St, Bentonville, AR 72712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e46-295e-774f-bbc6-bebcf242da12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e46-295e-774f-bbc6-bebcf242da12",
        "storage_key": "property/6737460151191756/019e1e46-295e-774f-bbc6-bebcf242da12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.waltonfamilyfoundation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9516794226651769720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walton-family-foundation-inc",
      "poi_latitude": "36.3744227",
      "poi_longitude": "-94.2104325",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 479-464-1570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e43-8f33-728b-993a-71b7e77b1c0e",
        "storage_key": "property/6737460151191756/019e1e43-8f33-728b-993a-71b7e77b1c0e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGeIbypkayYcReCsRUO1xEoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    }
  ],
  "office_hours": [
    {
      "id": "custom_714cf27b-0220-430d-8c29-0e59aadb7009",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e47a5b30-c420-4bf2-8b22-7e922a3ba16c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0f8d3085-fb02-4ba0-8879-4f15ea471011",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_096c1755-31d9-4fe1-b609-aaf084dbfe65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d5384b99-cbbf-4d36-b49a-26b09468413e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7f0124a3-e1a4-4d28-bfee-b5807e97e1ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_f897d53a-0917-4921-a5a8-582f5fd4fa6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "rating": "5.0",
      "name": "Chelsea Hudspeth",
      "text": "Pedro came to fix my dryer and got it done very efficiently. He always comes to complete my work orders quickly and is respectful of my space and cleans up after his completed work. Great team member!",
      "date": "2026-04-14",
      "title": ""
    },
    {
      "id": "custom_2e8f04b7-b617-429d-8c0e-777e45a48a02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "rating": "5.0",
      "name": "Tama Pawtchi",
      "text": "Thank you so much Jimmie for everything! It means the world. I love the little folder.",
      "date": "2026-04-07",
      "title": ""
    },
    {
      "id": "custom_e0947776-433f-4c44-bd5b-a0cea9a0f172",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "rating": "5.0",
      "name": "mckayla Lee",
      "text": "Jimmie Pool was very great and helpful. She was on top of getting things done and made the process super smooth.",
      "date": "2026-03-19",
      "title": ""
    },
    {
      "id": "custom_cdeed2df-e277-41af-9faf-3d71fc2db62f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "rating": "5",
      "name": "Hunter Lyon",
      "text": "Jimmie was amazing, she helped so much going through the process and making sure I got an apartment that would suit me best and I’m super excited to be with Glen Polo Park!",
      "date": "2025-11-04",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_dd116bcb-84e8-40bf-add1-f0e783bf63a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019e1e43-8048-73c5-b795-7bfc304c4266.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e43-8048-73c5-b795-7bfc304c4266",
        "storage_key": "property/6737460151191756/019e1e43-8048-73c5-b795-7bfc304c4266.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=669f2c892687e32eb634d696"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-da0d-74be-a1ed-79cade9a81d9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "glen-at-polo-park",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756"
    },
    {
      "lead_collector_id": "0198aa47-da6f-72d2-abf7-cec545060123",
      "lead_source": "FACEBOOK_ADS",
      "name": "glen-at-polo-park",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756"
    },
    {
      "lead_collector_id": "0198aa47-dad2-75b2-a2ab-f4badd9f9313",
      "lead_source": "LANDING_PAGE",
      "name": "glen-at-polo-park",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-bentonville-ar",
      "search_query": "dog-friendly apartments Bentonville AR",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Bentonville, AR",
      "h2_subtitle": "Experience unparalleled pet-friendly living at Glen at Polo Park. Our Bentonville apartments welcome your furry friends with open arms.",
      "page_copy": "Welcome to Glen at Polo Park in Bentonville, AR, where our dog-friendly apartments offer the perfect blend of comfort and convenience. With spacious layouts and a fantastic range of amenities, you and your pets will feel right at home. Enjoy strolls in our dedicated dog park, a safe haven for your pets to play and socialize. Our community is tailored to meet the needs of pet lovers, ensuring every member of your household, whether two-legged or four, enjoys a high quality of life.\n\nLocated in heartwarming Bentonville, AR, Glen at Polo Park provides a welcoming atmosphere for pet owners. Our community features two sparkling pools, a 24-hour fitness center, and an access gate for added peace of mind. Discover a vibrant community that embraces a pet-friendly lifestyle, encouraging joyful living for all our residents. Schedule a tour today and see why our residents and their furry companions love calling Glen at Polo Park their home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Bentonville, AR",
      "seo_description": "Explore pet-friendly living at Glen at Polo Park in Bentonville, AR. Enjoy amenities like a dog park. Perfect for you and your furry friends!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "apartments-with-24-hour-gym-benton-county",
      "search_query": "apartments with 24-hour gym Benton County",
      "category": "Amenity",
      "h1_title": "Benton County Apartments with 24-Hour Gym",
      "h2_subtitle": "Enjoy round-the-clock fitness access at Glen at Polo Park. Our Benton County apartments offer a fully equipped 24-hour gym.",
      "page_copy": "At Glen at Polo Park in Benton County, staying fit and active is easy with our 24-hour gym. Our apartments provide access to a state-of-the-art fitness center that allows residents to work out on their own schedule, whether you're an early bird or a night owl. With modern equipment and a spacious layout, our gym is designed to meet various fitness needs, ensuring you never have to compromise on your health and wellness goals.\n\nLocated in the thriving region of Benton County, Glen at Polo Park offers more than just a fitness center. Our community features an array of amenities including two sparkling pools, car wash stations, and a business center with equipment. Your comfort and convenience are our priority, providing you with the ideal living experience. Come and discover why Glen at Polo Park is the perfect choice for those seeking apartments with a comprehensive fitness facility and more.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Benton County Apartments with 24-Hour Gym",
      "seo_description": "Discover Glen at Polo Park's apartments with a 24-hour gym in Benton County. Enjoy modern fitness facilities and premium amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "luxury-apartments-near-72713-with-pools",
      "search_query": "pools in luxury apartments near 72713",
      "category": "Amenity",
      "h1_title": "Luxury Apartments Near 72713 with Pools",
      "h2_subtitle": "Relax in style at Glen at Polo Park, where luxury meets convenience. Our Bentonville apartments near 72713 feature two sparkling pools.",
      "page_copy": "Discover the epitome of luxury living at Glen at Polo Park, where our apartments near 72713 boast not one, but two stunning pools. These sparkling retreats provide the perfect escape from daily life, offering spaces to relax and rejuvenate. Whether you're swimming laps or soaking up the sun on our poolside deck, our community ensures a resort-style living experience right at your doorstep.\n\nLocated conveniently near the 72713 area, Glen at Polo Park stands out with premium amenities that go beyond our beautiful pools. Enjoy a vibrant lifestyle with our 24-hour fitness center, playgrounds, and car wash stations. Our luxurious apartments offer a harmonious blend of style and comfort, making us the premier choice for those seeking lavish living in Bentonville. Come see how Glen at Polo Park elevates apartment living with our exquisite pool facilities and more.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near 72713 with Pools",
      "seo_description": "Explore Glen at Polo Park's luxury apartments near 72713, featuring two stunning pools and premium amenities. Enjoy resort-style living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "gated-community-apartments-bentonville",
      "search_query": "apartments with gated community Bentonville",
      "category": "Amenity",
      "h1_title": "Gated Community Apartments in Bentonville",
      "h2_subtitle": "Experience secure living at Glen at Polo Park, a gated community in Bentonville. Our apartments offer peace of mind and enhanced privacy.",
      "page_copy": "Welcome to Glen at Polo Park, where our Bentonville apartments provide the perfect blend of security and comfort in a gated community setting. With an access gate that ensures added protection, you can enjoy the peace of mind that comes with enhanced privacy and security. Our gated community is designed to offer a tranquil living environment, perfect for those seeking a secure place to call home.\n\nBeyond the gated entry, our community offers a wide array of amenities including two sparkling pools, a 24-hour fitness center, and modern playgrounds. Our spacious apartment layouts and dedicated on-call maintenance service ensure that every need is met promptly. Glen at Polo Park is more than just apartments; it’s a lifestyle choice, offering the privacy of a gated community combined with luxurious features. Discover the perfect home for you in Bentonville today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Community Apartments in Bentonville",
      "seo_description": "Discover Glen at Polo Park's gated community in Bentonville. Enjoy heightened security, luxury amenities, and a tranquil living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "spacious-floor-plans-dog-park-bentonville",
      "search_query": "spacious floor plans with dog park Bentonville",
      "category": "Amenity",
      "h1_title": "Spacious Floor Plans & Dog Park in Bentonville",
      "h2_subtitle": "Glen at Polo Park offers spacious floor plans with a dog park in Bentonville. Enjoy the perfect home for you and your pet.",
      "page_copy": "At Glen at Polo Park, we understand the importance of space and amenities for both you and your furry friends. Our Bentonville community offers spacious floor plans that provide ample room for comfort and personalization. Choose from our one, two, or three-bedroom layouts, each designed with modern living in mind, ensuring a perfect fit for your lifestyle.\n\nAdditionally, pet lovers will appreciate our dedicated dog park, a secure and fun area where pets can play and socialize off-leash. This amenity enhances the community experience, offering a space where both residents and their pets can connect. Alongside our spacious apartments and pet-friendly park, Glen at Polo Park features outstanding amenities such as two pools and a fitness center, making it an ideal choice for those looking for a complete living experience in Bentonville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Floor Plans & Dog Park in Bentonville",
      "seo_description": "Glen at Polo Park offers spacious floor plans and a dog park in Bentonville. Enjoy modern living with ample space and amenities for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-bentonville-ar",
      "search_query": "one bedroom apartments bentonville ar",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Bentonville, AR",
      "h2_subtitle": "Find your perfect one-bedroom apartment at Glen at Polo Park in Bentonville, AR. Enjoy modern amenities and a convenient location.",
      "page_copy": "Explore our elegant one-bedroom apartments at Glen at Polo Park, located in the heart of Bentonville, AR. Each unit is designed with comfort and style in mind, offering a harmonious blend of modern amenities and spacious living areas. Our one-bedroom layouts provide the perfect sanctuary for singles or couples seeking a cozy yet roomy living environment.\n\nResidents enjoy premium features including a fully-equipped kitchen, sleek fixtures, and ample closet space. Beyond the confines of your apartment, take advantage of top-tier community amenities such as our 24-hour fitness center and inviting pools. Located in a vibrant neighborhood, Glen at Polo Park offers both tranquility and easy access to the dynamic lifestyle of Bentonville. Discover your new home with us today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Bentonville, AR",
      "seo_description": "Discover Glen at Polo Park's stylish one-bedroom apartments in Bentonville, AR. Enjoy modern amenities in a vibrant, convenient setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "two-bedroom-rentals-benton-county-ar",
      "search_query": "two bedroom rentals benton county ar",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Benton County, AR",
      "h2_subtitle": "Discover spacious two-bedroom rentals at Glen at Polo Park in Benton County, AR. Ideal for families or roommates seeking comfort and convenience.",
      "page_copy": "Welcome to Glen at Polo Park, where our two-bedroom rentals in Benton County, AR offer an ideal living space for families or roommates. Each apartment is thoughtfully designed with spacious interiors that accommodate a variety of lifestyles. Whether you're looking for a cozy spot to share with a roommate or a comfortable nest for a small family, our two-bedroom layouts provide ample room and privacy.\n\nIn addition to our spacious floor plans, residents enjoy access to a wide range of amenities that enhance the living experience. Take advantage of our two sparkling pools, state-of-the-art fitness center, and family-friendly playgrounds. Located in the heart of Benton County, Glen at Polo Park combines the benefits of contemporary living with the charm of a suburban community. Explore the possibilities of a lifestyle that fits you perfectly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals in Benton County, AR",
      "seo_description": "Explore Glen at Polo Park's two-bedroom rentals in Benton County, AR. Enjoy spacious layouts and modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-72713",
      "search_query": "three bedroom apartments near 72713",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 72713",
      "h2_subtitle": "Experience luxurious three-bedroom living at Glen at Polo Park, near the 72713 area. Perfect for families seeking space and comfort.",
      "page_copy": "Glen at Polo Park offers exceptional three-bedroom apartments near the 72713 area, catering to families and those needing extra space. Our thoughtfully designed floor plans provide a perfect blend of functionality and modern style, ensuring everyone has room to thrive. Each three-bedroom apartment features spacious living areas, cutting-edge appliances, and an inviting atmosphere that's perfect for creating lasting memories.\n\nOur community amenities complement the high-quality living experience, featuring two pools for relaxation, a dog park for your furry family members, and a fitness center open 24/7. Located just moments from the vibrant city life of Bentonville, Glen at Polo Park gives you the space you desire with the convenience you need. Discover three-bedroom apartments that elevate your living experience today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 72713",
      "seo_description": "Explore Glen at Polo Park's three-bedroom apartments near 72713. Enjoy spacious living with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "apartments-near-northwest-arkansas-community-college",
      "search_query": "apartments near northwest arkansas community college",
      "category": "School",
      "h1_title": "Apartments Near Northwest Arkansas Community College",
      "h2_subtitle": "Live close to Northwest Arkansas Community College at Glen at Polo Park. Our apartments offer convenience and modern amenities.",
      "page_copy": "Looking for apartments near Northwest Arkansas Community College? Glen at Polo Park provides the perfect home base for students and faculty, combining comfort and proximity in one. Our community offers a variety of apartment layouts, including one, two, and three-bedroom options, ensuring you'll find the perfect fit for your needs.\n\nEnjoy a range of amenities designed to enhance your living experience, such as a state-of-the-art fitness center, refreshing swimming pools, and a business center equipped for study sessions. Easily commute to campus, thanks to our strategic location in Bentonville, AR. Whether you're studying late or starting early, Glen at Polo Park offers the ideal blend of convenience, comfort, and lifestyle enhancement.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northwest Arkansas Community College",
      "seo_description": "Discover Glen at Polo Park, offering quality apartments near Northwest Arkansas Community College. Enjoy modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "glen-at-polo-park-near-john-brown-university",
      "search_query": "glen at polo park near john brown university",
      "category": "School",
      "h1_title": "Glen at Polo Park Near John Brown University",
      "h2_subtitle": "Discover the ideal living environment at Glen at Polo Park, a short drive from John Brown University. Enjoy a premium lifestyle in Bentonville.",
      "page_copy": "Glen at Polo Park offers an exceptional living experience just a quick drive from John Brown University. Located in Bentonville, AR, our community is perfect for students and faculty seeking a comfortable residence with easy access to the university. Choose from our wide selection of one, two, and three-bedroom apartments that cater to diverse living preferences.\n\nResidents are treated to a variety of amenities designed to create a convenient and enjoyable lifestyle. With access to a 24-hour fitness center, two sparkling swimming pools, and a business center equipped with the essentials, Glen at Polo Park provides everything you need to balance academics and relaxation. Experience the perfect blend of location and luxury living near John Brown University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Glen at Polo Park Near John Brown University",
      "seo_description": "Explore Glen at Polo Park, conveniently located near John Brown University. Enjoy luxury living with modern amenities in Bentonville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "apartments-close-to-university-of-arkansas-bentonville",
      "search_query": "apartments close to university of arkansas bentonville",
      "category": "School",
      "h1_title": "Apartments Close to University of Arkansas Bentonville",
      "h2_subtitle": "Glen at Polo Park offers premium apartments close to the University of Arkansas in Bentonville, perfect for students and faculty alike.",
      "page_copy": "Located in the heart of Bentonville, Glen at Polo Park presents the perfect apartment living experience close to the University of Arkansas. Our community is ideal for students and faculty seeking spacious and modern accommodations just a short commute from campus. Choose from our selection of one, two, or three-bedroom apartments tailored to meet your lifestyle needs.\n\nAt Glen at Polo Park, enjoy access to top-notch amenities such as a 24-hour fitness center, two gleaming swimming pools, and a dedicated business center. These features combined with our convenient location make balancing academics and leisure a breeze. Experience comfortable living and easy access to university life at Glen at Polo Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to University of Arkansas Bentonville",
      "seo_description": "Find your new home at Glen at Polo Park, offering spacious apartments close to the University of Arkansas Bentonville with modern amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "glen-at-polo-park-near-spring-hill-middle-school",
      "search_query": "glen at polo park near spring hill middle school",
      "category": "School",
      "h1_title": "Glen at Polo Park Near Spring Hill Middle School",
      "h2_subtitle": "Discover family-friendly living at Glen at Polo Park, conveniently located near Spring Hill Middle School in Bentonville, AR.",
      "page_copy": "Experience the perfect blend of comfort and convenience at Glen at Polo Park, located near Spring Hill Middle School in Bentonville, AR. Our community offers a family-friendly environment with spacious one, two, and three-bedroom floor plans designed to meet the needs of growing families. \n\nAt Glen at Polo Park, residents enjoy premium amenities such as two playgrounds for kids, a refreshing swimming pool, and a fitness center that’s open 24 hours. Our location near Spring Hill Middle School makes it easy for families to navigate the school commute, allowing more quality time together. Explore the vibrant lifestyle and community spirit at Glen at Polo Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Glen at Polo Park Near Spring Hill Middle School",
      "seo_description": "Live close to Spring Hill Middle School at Glen at Polo Park, offering family-friendly apartments with top amenities in Bentonville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "apartments-near-founders-classical-academies-bentonville",
      "search_query": "apartments near founders classical academies bentonville",
      "category": "School",
      "h1_title": "Apartments Near Founders Classical Academies Bentonville",
      "h2_subtitle": "Explore family-oriented living at Glen at Polo Park, where you'll find inviting apartments near Founders Classical Academies in Bentonville.",
      "page_copy": "Discover Glen at Polo Park, a community offering excellent apartments close to Founders Classical Academies in Bentonville, AR. Our thoughtfully designed one, two, and three-bedroom floor plans provide plenty of space and modern convenience for families and individuals alike, all within easy reach of the school.\n\nEnjoy an array of amenities that enhance your lifestyle, including a dog park, two sparkling pools, and a business center with equipment. With its ideal location near Founders Classical Academies, Glen at Polo Park makes balancing education, work, and leisure effortless. Come home to comfort and convenience at Glen at Polo Park today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Founders Classical Academies Bentonville",
      "seo_description": "Glen at Polo Park offers convenient apartments near Founders Classical Academies Bentonville, featuring modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "apartments-near-reagan-elementary-school-bentonville",
      "search_query": "apartments near reagan elementary school bentonville",
      "category": "School",
      "h1_title": "Apartments Near Reagan Elementary School Bentonville",
      "h2_subtitle": "Glen at Polo Park offers comfortable living with apartments near Reagan Elementary School in Bentonville, ideal for families with young children.",
      "page_copy": "Glen at Polo Park is the perfect choice for families looking for comfortable apartments near Reagan Elementary School in Bentonville, AR. Our community features spacious one, two, or three-bedroom floor plans that cater to the needs of both individuals and families striving for convenience near educational facilities.\n\nOur residents benefit from first-rate amenities such as two playgrounds, ensuring fun for children, and a 24-hour fitness center for active lifestyles. Being in close proximity to Reagan Elementary School offers families an easy daily commute, so you can enjoy more precious time spent together. Embrace the welcoming atmosphere at Glen at Polo Park, where the comfort of home meets educational convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Reagan Elementary School Bentonville",
      "seo_description": "Find family-friendly apartments near Reagan Elementary School at Glen at Polo Park, featuring spacious floor plans and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "apartments-close-to-bentonville-west-high-school",
      "search_query": "apartments close to bentonville west high school",
      "category": "School",
      "h1_title": "Apartments Close to Bentonville West High School",
      "h2_subtitle": "Discover stylish living at Glen at Polo Park, offering modern apartments close to Bentonville West High School in Bentonville, AR.",
      "page_copy": "Nestled in the heart of Bentonville, AR, Glen at Polo Park offers convenient living with contemporary apartments close to Bentonville West High School. Our community is perfect for families and individuals seeking easy access to education while enjoying spacious one, two, or three-bedroom floor plans.\n\nResidents can take advantage of premium amenities including a business center with equipment and two pristine pools, complemented by our 24-hour on-call maintenance team. Living close to Bentonville West High School ensures that students and parents alike benefit from a stress-free commute, leaving more time to enjoy the vibrant community life at Glen at Polo Park. Experience the best of both worlds with comfort and convenience at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Bentonville West High School",
      "seo_description": "Enjoy convenience with apartments close to Bentonville West High School at Glen at Polo Park, featuring spacious floor plans and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191756",
      "source": "generator",
      "page_item_url": "glen-at-polo-park-near-life-way-christian-school",
      "search_query": "glen at polo park near life way christian school",
      "category": "School",
      "h1_title": "Glen at Polo Park Near Life Way Christian School",
      "h2_subtitle": "Experience tranquil living at Glen at Polo Park, located near Life Way Christian School in Bentonville, AR, and discover an ideal family-friendly community.",
      "page_copy": "Glen at Polo Park presents a peaceful community environment, conveniently located near Life Way Christian School in Bentonville, AR. Our inviting one, two, and three-bedroom floor plans provide ample space and modern amenities, making it an attractive choice for families focused on balancing home and education.\n\nWith quick access to Life Way Christian School, getting to and from school is effortless. Residents enjoy a suite of amenities, including a dog park for your furry friends, two refreshing pools, and a gated access system for added security. Choose Glen at Polo Park for a seamless blend of modern comfort and proximity to educational institutions, creating a perfect home environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
      "featured_image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, dresser, and large mirror.",
        "public_id": "019d076d-8247-77ec-b585-6e1fa77d839f",
        "storage_key": "property/6737460151191756/019d076d-8247-77ec-b585-6e1fa77d839f.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Glen at Polo Park Near Life Way Christian School",
      "seo_description": "Glen at Polo Park offers spacious living near Life Way Christian School in Bentonville, featuring modern amenities and a family-friendly atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3351"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483387"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5026489"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KTGFDR6M"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "479-346-4155"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "479-777-4159"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "479-348-2253"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "479-339-8538"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "479-370-1615"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "479-348-1606"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "479-398-2135"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "479-341-1427"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "479-348-4372"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "479-391-3259"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "479-324-4318"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "479-383-2633"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "479-847-7161"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "479-275-4436"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "479-929-8739"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "479-777-8012"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "479-348-0840"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "479-315-6228"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321141054"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "479-346-2795"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "479-345-2129"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "159b11eed49e436c"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "479-345-6611"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "479-397-3557"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "479-262-0420"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "479-239-9812"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "479-315-6284"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "479-239-9848"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "479-341-2319"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "479-339-4961"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.glenpolopark.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191756/019e60ee-630d-7512-ad20-e959b9e172eb.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "479-239-8913"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "479-391-3259"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3351",
  "custom_repli_id": "5028483387",
  "custom_realpage_id": "5026489",
  "custom_knock_a_link": "https://www.glenpolopark.com?utm_knock=a",
  "custom_knock_g_link": "https://www.glenpolopark.com?utm_knock=g",
  "custom_knock_r_link": "https://www.glenpolopark.com?utm_knock=r",
  "custom_knock_w_link": "https://www.glenpolopark.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-KTGFDR6M",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.glenpolopark.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.glenpolopark.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.glenpolopark.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.glenpolopark.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.glenpolopark.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.glenpolopark.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "479-346-4155",
  "custom_knock_ads_link": "https://www.glenpolopark.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.glenpolopark.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "479-777-4159",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.glenpolopark.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.glenpolopark.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.glenpolopark.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.glenpolopark.com?utm_knock=psa",
  "custom_knock_r_number": "479-348-2253",
  "custom_knock_w_number": "479-339-8538",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "479-370-1615",
  "custom_knock_amap_link": "https://www.glenpolopark.com?utm_knock=amap",
  "custom_knock_ar_number": "479-348-1606",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "479-398-2135",
  "custom_knock_fb_number": "479-341-1427",
  "custom_knock_fl_number": "479-348-4372",
  "custom_knock_gp_number": "479-391-3259",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.glenpolopark.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "479-324-4318",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.glenpolopark.com?utm_knock=bcard",
  "custom_knock_bnr_number": "479-383-2633",
  "custom_knock_cfres_link": "https://www.glenpolopark.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "479-847-7161",
  "custom_knock_lgp_number": "479-275-4436",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.glenpolopark.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "479-929-8739",
  "custom_knock_psa_number": "479-777-8012",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "479-348-0840",
  "custom_knock_bandit_link": "https://www.glenpolopark.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.glenpolopark.com?utm_knock=flyers",
  "custom_knock_osoc_number": "479-315-6228",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321141054",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "479-346-2795",
  "custom_knock_cfres_number": "479-345-2129",
  "custom_knock_chatgpt_link": "https://www.glenpolopark.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "159b11eed49e436c",
  "custom_knock_dirmail_link": "https://www.glenpolopark.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "479-345-6611",
  "custom_knock_propbro_link": "https://www.glenpolopark.com?utm_knock=propbro",
  "custom_knock_bandit_number": "479-397-3557",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "479-262-0420",
  "custom_knock_outbound_link": "https://www.glenpolopark.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.glenpolopark.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "479-239-9812",
  "custom_knock_dirmail_number": "479-315-6284",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "479-239-9848",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "479-341-2319",
  "custom_knock_revcards_number": "479-339-4961",
  "custom_knock_maintenance_link": "https://www.glenpolopark.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191756/019e60ee-630d-7512-ad20-e959b9e172eb.mp4",
  "custom_knock_maintenance_number": "479-239-8913",
  "custom_ppc_tracking_phone_number": "479-391-3259"
};

export const generatedAt = '2026-10-07T17:16:13.670Z';
